"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.PAGE_SCROLL_ID = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator4 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("react-mdl/extra/material");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _LogStore = _interopRequireDefault(require("../../../KESI2/Stores/LogStore"));

var _DataStoreAblyHelper = _interopRequireDefault(require("../../../utils/DataStoreAblyHelper"));

var _UsageStore = _interopRequireDefault(require("../../../KESI2/Services/UsageService/Stores/UsageStore2"));

var _EquizzerActions = _interopRequireDefault(require("../../components/Equizzer/actions/EquizzerActions"));

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _RelevancesActions = _interopRequireDefault(require("../../../KESI2/Services/RelevancesService/Stores/RelevancesActions2"));

var _RelevancesService = _interopRequireDefault(require("../../../KESI2/Services/RelevancesService"));

var _RelevancesStore = _interopRequireDefault(require("../../../KESI2/Services/RelevancesService/Stores/RelevancesStore2"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _LogService = _interopRequireWildcard(require("../../../KESI2/Services/LogService"));

var _RemoteControlledService = require("../../../KESI2/Services/RemoteControlledService");

var _AppChannel = require("../../../KESI2/Services/AppChannel");

var _AlertHelper = _interopRequireWildcard(require("../../../helpers/AlertHelper"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../helpers/CordovaFileHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _strings = require("../../../../config/strings");

var _strings2 = require("./strings");

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _NavigationBar = _interopRequireDefault(require("../../../../targets/cord_sanofi/NavigationBar.js"));

var _ErvBottomBar = _interopRequireDefault(require("../ErvBottomBar/ErvBottomBar"));

var _BottomBar = _interopRequireDefault(require("../BottomBar/BottomBar"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _base = _interopRequireDefault(require("../../styles/base.scss"));

var _AppCordovaGeneric = _interopRequireDefault(require("./AppCordovaGeneric.scss"));

var _AppUtils = require("../../../utils/AppUtils");

var _index = require("../../../KESI2/Services/RemoteControlService/index");

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _UserAgent = require("../../../utils/UserAgent");

var _DataMigrator = _interopRequireDefault(require("../../../KESI2/Stores/DataMigrator"));

var _AppNativeStorage = require("../../../utils/AppNativeStorage");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _KeyboardHelper = require("../../../helpers/KeyboardHelper");

var _FlexMenuHelper = require("../../../helpers/FlexMenuHelper");

var _MuiAlertHelper = _interopRequireWildcard(require("../../../helpers/MuiAlertHelper"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _CordovaHelper = require("../../../helpers/CordovaHelper");

var _UserManagementService = _interopRequireDefault(require("../Equizzer/services/UserManagementService"));

var _MessagingService = _interopRequireDefault(require("../../../KESI2/Services/MessagingService"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _UsageService = require("../../../KESI2/Services/UsageService");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DeviceTracking = _interopRequireDefault(require("../../../tracking/DeviceTracking"));

var _SnackbarHelper = _interopRequireWildcard(require("../../../helpers/SnackbarHelper"));

var _Glossary = _interopRequireDefault(require("../Glossary/Glossary"));

var _SysMessageHelper = require("../../../helpers/SysMessageHelper");

var _Chat = require("../Chat/Chat");

var _AblyMessagingCommands = require("../../constants/AblyMessagingCommands");

var _ErgoStructureHelper = require("../../../helpers/ErgoStructureHelper");

var _ErgoActivityConstants = require("../ErgoActivity/ErgoActivityConstants");

var _PushHelper = _interopRequireDefault(require("../../../helpers/PushHelper"));

var _ResumeSuspendListeners = require("../../../helpers/ResumeSuspendListeners");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _BuildConstants = require("../../../utils/BuildConstants");

var _UrlHelper = _interopRequireDefault(require("../../../helpers/UrlHelper"));

var _OnlineAlertHelper = _interopRequireDefault(require("../../../helpers/OnlineAlertHelper"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _BookingHelper = require("../../../helpers/BookingHelper");

var _DeeplinkHelper = require("../../../helpers/DeeplinkHelper");

var _core = require("@material-ui/core");

var _EquizzerRegisterHelper = require("../Equizzer/EquizzerRegisterHelper");

var _PauseHelper = _interopRequireDefault(require("../../../helpers/PauseHelper"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator4["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PAGE_SCROLL_ID = 'pageScrollDiv';
exports.PAGE_SCROLL_ID = PAGE_SCROLL_ID;
var SCREEN_ORIENTATION_LOCK_TIMEOUT = 15000; // 15 seconds

var MIN_TIME_BETWEEN_CONTENT_UPDATE_AVAILABLE_ALERTS = 5 * 60 * 1000;
var TIME_AFTER_THAT_RESUME_WILL_BE_HANDLED_AS_RELOAD = 3600000;
var onPageScrollListeners = [];
var remoteScrollCallbacks = {};
var SPLASH_SCREEN_VIDEO_ID = 'splashscreenVideo';

function getContext() {
  return {
    contentStore: _ContentStore["default"],
    dataStore: _DataStore["default"],
    themeStore: _ThemeStore["default"],
    usageStore: _UsageStore["default"],
    relevancesStore: _RelevancesStore["default"]
  };
} // injectTapEventPlugin()

/**
 * TODO handle sys messages
 **/


var AppCordovaGeneric = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(AppCordovaGeneric, _DataStoreComponent);

  var _super = _createSuper(AppCordovaGeneric);

  function AppCordovaGeneric(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, AppCordovaGeneric);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkForInitialPush", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var pushPayload;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.FCM) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return window.FCM.getInitialPushPayload();

            case 3:
              pushPayload = _context.sent;

              if (pushPayload) {
                _this.onNotificationReceived(pushPayload);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBackKeyDown", function () {
      console.log('onBackKeyDown');

      if (!_this.state.showSettingsDialog) {
        if (!_this.state.backButtonFunc || _this.state.backButtonFunc.length === 0) {
          if (_config["default"].baseRoute + '/' + _NavigationManagerCordova["default"].getCurrentPath() !== _config["default"].cordovaStartUrl()) {
            _NavigationManagerCordova["default"].goHome();
          } else {
            navigator.app.exitApp();
          }
        } else {
          _NavigationManagerCordova["default"].goBack();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "playSplashScreenVideo", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var splashScreenVideo;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              splashScreenVideo = document.getElementById(SPLASH_SCREEN_VIDEO_ID);

              if (splashScreenVideo) {
                splashScreenVideo.oncanplaythrough = function () {
                  splashScreenVideo.play();
                }; // playable
                // the events are not properly thrown on all devices


                splashScreenVideo.play();
                splashScreenVideo.pause();
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAppSuspend", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.appSuspended = true;
              _this.appSuspendedCounter += 1;

              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SUSPEND_TIME, (0, _now["default"])());

              console.log('app suspend');

              if (_config["default"].isSafetureApp) {
                (0, _LogService.pushTravelAndCareLogMessage)('app_suspend');
              } else {
                (0, _LogService.pushGenericLogMessage)({
                  action: 'app_suspend'
                });
              }

              _this.disconnectFromTargetChannelPresences();

              _this.setState({
                registeredAsSlave: false,
                updateCheckComplete: false
              });

              _this.unregisterFromTargetSpecificChannels();

              (0, _AppChannel.unregister)(_this.onMessageForThisApp, 'AppCordova');
              (0, _RemoteControlledService.unregister)(_this.onMessageForSlave);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAppResume", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var suspendTime, updateAvailable, wasSuspended, path, id;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // read comment above
              // if (!this.appSuspended) {
              //   return
              // }
              suspendTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SUSPEND_TIME);
              updateAvailable = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE);

              if (!(updateAvailable && (0, _now["default"])() - suspendTime > TIME_AFTER_THAT_RESUME_WILL_BE_HANDLED_AS_RELOAD)) {
                _context4.next = 7;
                break;
              }

              console.log('App was resumed too long -> reload');

              _NavigationManagerCordova["default"].goHome(true);

              (0, _LogService.pushTravelAndCareLogMessage)('app_update_restart');
              return _context4.abrupt("return");

            case 7:
              wasSuspended = _this.appSuspended && _this.appSuspendedCounter > 0;
              _this.appSuspended = false; // this.branchInit()

              console.log('app resume');

              if (_config["default"].isSafetureApp) {
                (0, _LogService.pushTravelAndCareLogMessage)('app_resume');
              } else {
                (0, _LogService.pushGenericLogMessage)({
                  action: 'app_resume'
                });
              }

              path = _NavigationManagerCordova["default"].getCurrentPath();

              if (path) {
                id = _NavigationManagerCordova["default"].getCurrentId();
                (0, _LogService["default"])(id, path);
              }

              console.log('register for app channel resume');
              (0, _AppChannel.register)(_this.onMessageForThisApp, 'AppCordova');

              _this.registerTargetSpecificChannels();

              _this.connectToTargetChannels();

              _this.connectToTargetChannelPresences();

              if (!_this.state.registeredAsSlave) {
                _this.setState({
                  registeredAsSlave: true
                });

                (0, _RemoteControlledService.register)(_this.onMessageForSlave);
              }

              if (_config["default"].loadVisibilities) {
                _KESI2Helper["default"].getVisibilities();
              } // if (target.isSafetureApp) {
              // get the data store from the server and check for push messages


              _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.SERVER).then(function () {
                if (!_this.appSuspended) {
                  // app may be suspended in the meantime
                  (0, _SysMessageHelper.handleSysMessages)((0, _assertThisInitialized2["default"])(_this));
                }
              }); // }


              if (_config["default"].usesAnalyzer) {
                _RelevancesService["default"].updateFromServer();
              }

              if (!(!_config["default"].useWebLogin && !_config["default"].isSafetureApp)) {
                _context4.next = 31;
                break;
              }

              _context4.prev = 23;
              _context4.next = 26;
              return _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.PUBLIC);

            case 26:
              _context4.next = 31;
              break;

            case 28:
              _context4.prev = 28;
              _context4.t0 = _context4["catch"](23);
              console.error('error while getting data store from server', _context4.t0);

            case 31:
              if (!_this.appSuspended) {
                _context4.next = 33;
                break;
              }

              return _context4.abrupt("return");

            case 33:
              if (!(wasSuspended && !_this.state.loading)) {
                _context4.next = 47;
                break;
              }

              if (!(!_this.state.showBackButton || _config["default"].ignoreRouteForUpdateOnAppResume)) {
                _context4.next = 38;
                break;
              }

              // Comment out for ERGO TESTING
              if ((0, _now["default"])() - suspendTime > MIN_TIME_BETWEEN_CONTENT_UPDATE_AVAILABLE_ALERTS) {
                _this.updateContent(true, false, null, false);
              } else {
                console.log('do not check for new content after short resume');
              }

              _context4.next = 47;
              break;

            case 38:
              _context4.prev = 38;
              _context4.next = 41;
              return _KESI2Helper["default"].isUpdateAvailable();

            case 41:
              _this.isUpdateAvailable = _context4.sent;
              _context4.next = 47;
              break;

            case 44:
              _context4.prev = 44;
              _context4.t1 = _context4["catch"](38);
              console.error('error checking for update at app resume', _context4.t1);

            case 47:
              if (_config["default"].collectTrackingInformation) {
                _DeviceTracking["default"].trackNow();
              }

              _this.onAppResumeDone();

            case 49:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[23, 28], [38, 44]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDeviceReady", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var permissions, creationDate, appInstance, clientId, search, USER_AGENT, el, nickNameForQD, feature, nickName;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this.deviceReadyCalled) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              _this.deviceReadyCalled = true;

              _this.showAnimatedSplashscreen();

              (0, _AppNativeStorage.setStorageShouldBeAvailable)(true);
              _context6.next = 7;
              return _this.initStores();

            case 7:
              _context6.next = 9;
              return _this.onStoresInitialized();

            case 9:
              _context6.next = 11;
              return _this.setDataStoreValuesAccordingToConfig();

            case 11:
              if (window.universalLinks) {
                window.universalLinks.subscribe(null, _this.handleActivityOpenedByDeeplink);
              }

              if (!_DeviceInfoHelper["default"].isBrowser()) {
                try {
                  if (cordova && cordova.InAppBrowser) {
                    window.open = cordova.InAppBrowser.open;
                  }
                } catch (e) {
                  console.log('cordova error', e);
                }
              }

              console.log('ANDROID VERSION', _DeviceInfoHelper["default"].getAndroidVersion());

              if (!(_DeviceInfoHelper["default"].isiOS() && window.FCMPlugin && window.FCMPlugin.requestPushPermissionIOS)) {
                _context6.next = 18;
                break;
              }

              window.FCMPlugin.requestPushPermissionIOS();
              _context6.next = 26;
              break;

            case 18:
              if (!(window.FCM && window.FCM.requestPushPermission)) {
                _context6.next = 22;
                break;
              }

              window.FCM.requestPushPermission();
              _context6.next = 26;
              break;

            case 22:
              if (!(_DeviceInfoHelper["default"].isAndroid() && window.cordova.plugins.permissions && _DeviceInfoHelper["default"].getAndroidVersion() > 12)) {
                _context6.next = 26;
                break;
              }

              permissions = window.cordova.plugins.permissions;
              _context6.next = 26;
              return permissions.requestPermission(permissions.POST_NOTIFICATIONS, function () {
                return console.log('android push allowed');
              }, function () {
                return console.log('android push denied');
              });

            case 26:
              console.log('store loaded and migrated');

              if (_config["default"].isSafetureApp) {
                (0, _LogService.pushTravelAndCareLogMessage)('app_start');
              } else {
                (0, _LogService.pushGenericLogMessage)({
                  action: 'app_start'
                });
              }

              if (!_config["default"].isSafetureApp) {
                _this.showWelcomeAlert();
              } // const elementsExistBeneathDevice = Object.keys(DataStore.getElementByPathImmediately(DATA_STORE_PATHS.DEVICE)).length > 1


              creationDate = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_CREATION_DATE);
              appInstance = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.APP_INSTANCE);

              if (!(_config["default"].clearStorageOnStart && _config["default"].useWebLogin && !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) && appInstance && (0, _keys["default"])(appInstance).length > 0 && (!creationDate || creationDate < (0, _now["default"])() - 15000))) {
                _context6.next = 36;
                break;
              }

              _context6.next = 34;
              return (0, _CordovaHelper.logOut)(true, _this.setDataStoreValuesAccordingToConfig, false, 'AppCordovaGeneric onDeviceReady clearStorageOnStart');

            case 34:
              console.log('storage cleared');
              return _context6.abrupt("return");

            case 36:
              if (!(_config["default"].useEurofhLinkId && appInstance)) {
                _context6.next = 44;
                break;
              }

              _context6.next = 39;
              return _DataStore["default"].resetStore();

            case 39:
              // restore ably enabled
              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED, true);

              _context6.next = 42;
              return _RegisterInstance["default"].init();

            case 42:
              _context6.next = 52;
              break;

            case 44:
              if (!(_config["default"].useDeutscheWohnenId && appInstance)) {
                _context6.next = 52;
                break;
              }

              clientId = null;

              if (_DeviceInfoHelper["default"].isBrowser()) {
                search = window.location.search;
                clientId = search.replace(/(.*clientId=)([^&]+)(.*)/, '$2');
                if (clientId === search) clientId = null;
              }

              if (!(!clientId || appInstance.instanceId !== clientId)) {
                _context6.next = 52;
                break;
              }

              _context6.next = 50;
              return _DataStore["default"].resetStore();

            case 50:
              _context6.next = 52;
              return _RegisterInstance["default"].init();

            case 52:
              _this.setState({
                deviceReady: true,
                dataStoreReady: true
              });

              _this.setLanguage();

              _RegisterInstance["default"].init();

              (0, _AppChannel.register)(_this.onMessageForThisApp, 'AppCordova'); // TODO: if app is online, callback is registered twice. Once here and in online listener. (Resulting in 2 calls)
              // registerForConnectChannel(that.onMessageForThisApp, 'AppCordova')

              _context6.prev = 56;
              _context6.next = 59;
              return _MessagingService["default"].init();

            case 59:
              _context6.next = 64;
              break;

            case 61:
              _context6.prev = 61;
              _context6.t0 = _context6["catch"](56);
              console.error('Error initializing MessagingService', _context6.t0);

            case 64:
              if (_config["default"].useFeedbackService || _config["default"].hasLikeFunctionalityForNuggets || _config["default"].hasLikeFunctionalityForLectures) {
                console.log('init FeedbackService', _config["default"].useFeedbackService, _config["default"].hasLikeFunctionalityForLectures, _config["default"].hasLikeFunctionalityForNuggets); // don't use await here as initFeedbackService is quite blocking if device is offline

                (0, _FeedbackService.init)()["catch"](function (error) {
                  console.error('Error initializing FeedbackService', error);
                });
              }

              if (!_config["default"].useUsageService) {
                _context6.next = 74;
                break;
              }

              _context6.prev = 66;
              _context6.next = 69;
              return (0, _UsageService.init)();

            case 69:
              _context6.next = 74;
              break;

            case 71:
              _context6.prev = 71;
              _context6.t1 = _context6["catch"](66);
              console.error('Error initializing UsageService', _context6.t1);

            case 74:
              _this.registerTargetSpecificChannels();

              _this.registerForNotifications();

              _this.appsflyerInit();

              if (!_config["default"].useLanguageParam) {
                _context6.next = 80;
                break;
              }

              _context6.next = 80;
              return _this.checkUrl();

            case 80:
              if (window.screen.orientation && _config["default"].onlyPortrait) {
                window.screen.orientation.lock('portrait');
              }

              if (window.UserAgent && !_DeviceInfoHelper["default"].isBrowser() && _config["default"].redefineUserAgent) {
                USER_AGENT = (0, _UserAgent.getUserAgent)();
                console.log("redefining User-Agent to ".concat(USER_AGENT));
                window.UserAgent.set(USER_AGENT);
              } else {
                console.log("window.UserAgent not available! Can't set custom User-Agent.");
              }

              if (!_DeviceInfoHelper["default"].isBrowser()) {
                window.screen.orientation.addEventListener('change', _this.onOrientationChange);
              }

              if (_config["default"].loadVisibilities) {
                _KESI2Helper["default"].getVisibilities();
              }

              if (!(!_config["default"].useWebLogin || _DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true))) {
                _context6.next = 95;
                break;
              }

              _context6.prev = 85;
              _context6.next = 88;
              return _this.loadContent();

            case 88:
              _context6.next = 93;
              break;

            case 90:
              _context6.prev = 90;
              _context6.t2 = _context6["catch"](85);
              console.error('error loadContent in deviceReady (=> ignored)', _context6.t2);

            case 93:
              _context6.next = 96;
              break;

            case 95:
              if (navigator.splashscreen && !_config["default"].useSplashScreenToHideLoading) {
                navigator.splashscreen.hide();

                if (_this.pathToGoAfterContentLoad) {
                  _NavigationManagerCordova["default"].goTo(_this.pathToGoAfterContentLoad);
                }
              }

            case 96:
              _this.canLoadContentOnlyFromDeviceReady = false;

              if (!_config["default"].userSelectText) {
                document.body.style.WebkitUserSelect = 'none';
                document.body.style.userSelect = 'none';
              } // setContentUpdateFn(that.reloadContent)


              (0, _AppUtils.setContentUpdateFn)(_this.updateContent);
              (0, _AppUtils.setAppInstance)((0, _assertThisInitialized2["default"])(_this));
              (0, _AppUtils.setHideBottomBarFn)( /*#__PURE__*/function () {
                var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(hidden) {
                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!(_this.state.hideBottomBar !== hidden)) {
                            _context5.next = 2;
                            break;
                          }

                          return _context5.abrupt("return", new _promise["default"](function (resolve) {
                            _this.setState({
                              hideBottomBar: hidden
                            }, resolve);
                          }));

                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x) {
                  return _ref6.apply(this, arguments);
                };
              }());

              if (!(!_config["default"].isSafetureApp && (!_config["default"].useWebLogin || _config["default"].isLoggedIn()))) {
                _context6.next = 110;
                break;
              }

              _context6.prev = 102;
              _context6.next = 105;
              return _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.PUBLIC);

            case 105:
              _context6.next = 110;
              break;

            case 107:
              _context6.prev = 107;
              _context6.t3 = _context6["catch"](102);
              console.error('error while getting data store from server', _context6.t3);

            case 110:
              if (!_DeviceInfoHelper["default"].isInternetExplorer()) {
                _context6.next = 116;
                break;
              }

              el = document.getElementById('app');

              if (el) {
                el.style.zIndex = '1';
                el.style.position = 'relative';
              }

              if (!_config["default"].disableTileAnimationOnIE) {
                _context6.next = 116;
                break;
              }

              _context6.next = 116;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION, true);

            case 116:
              if (_config["default"].collectTrackingInformation) {
                _DeviceTracking["default"].trackNow();
              }

              if (!_config["default"].isDegesWebApp) {
                _context6.next = 121;
                break;
              }

              _context6.next = 120;
              return (0, _BookingHelper.checkBookingTags)();

            case 120:
              setTimeout(function () {
                // there seems to be a timing issue -> hard fix for now, do it again after 5 seconds
                (0, _BookingHelper.checkBookingTags)();
              }, 5000);

            case 121:
              if (!(_config["default"].useQDinBase && _config["default"].useWebLogin && _config["default"].isLoggedIn())) {
                _context6.next = 133;
                break;
              }

              nickNameForQD = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BASE_QD_NICKNAME);

              if (!nickNameForQD) {
                _context6.next = 128;
                break;
              }

              _context6.next = 126;
              return (0, _EquizzerRegisterHelper.registerUserForQDInKesi)(nickNameForQD);

            case 126:
              _context6.next = 133;
              break;

            case 128:
              // we dont have a nickname yet, the kesi nickname will be the smart finanz nickname
              feature = _FeatureManager["default"].getFeature(_config["default"].requiredFeature);

              if (!(feature && feature.additionalData && feature.additionalData.nickName)) {
                _context6.next = 133;
                break;
              }

              nickName = feature.additionalData.nickName;
              _context6.next = 133;
              return (0, _EquizzerRegisterHelper.registerUserForQDInKesi)(nickName);

            case 133:
              _this.checkForInitialPush();

              _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.SERVER).then(function () {
                (0, _SysMessageHelper.handleSysMessages)((0, _assertThisInitialized2["default"])(_this));
              });

              _context6.next = 137;
              return _this.checkUrlParams();

            case 137:
              _context6.next = 139;
              return _this.onDeviceReadyDone();

            case 139:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[56, 61], [66, 71], [85, 90], [102, 107]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleActivityOpenedByDeeplink", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(eventData) {
        var isRetry,
            pathSplits,
            path,
            expectedMd5,
            urlParams,
            contentPathArray,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                isRetry = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                (0, _LogService.pushGenericLogMessage)({
                  action: isRetry ? 'deeplink-offline_retry' : 'deeplink',
                  message: eventData
                });

                if (eventData && eventData.path) {
                  pathSplits = eventData.path.split('/');
                  path = pathSplits[pathSplits.length - 1];
                  expectedMd5 = eventData.hash;
                  urlParams = _UrlHelper["default"].getUrlParams(eventData.path);

                  if (urlParams.referrer) {
                    _this.retrieveAndHandleConfigMessages(urlParams.referrer);
                  }

                  if (path.length > 0 && path[0] === 'c') {
                    // content link look like this: (UUID = content uuid)
                    // https://PREFIX.onelink.me/ABCD/cUUID_UUID#8ac63e812a00
                    contentPathArray = path.substring(1).length > 0 ? path.substring(1).split('_') : null;

                    if (contentPathArray) {
                      (0, _DeeplinkHelper.goToContent)(contentPathArray, expectedMd5);
                    }
                  }
                }

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "appsflyerInit", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
      var shouldInitAppsflyer, referrer, options;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!_config["default"].alwaysActivateAppsflyer && !_config["default"].activateAppsflyerUntilReferred)) {
                _context8.next = 3;
                break;
              }

              _this.setState({
                deepLinkChecked: true
              });

              return _context8.abrupt("return");

            case 3:
              shouldInitAppsflyer = _config["default"].alwaysActivateAppsflyer;

              if (!shouldInitAppsflyer) {
                referrer = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.APPSFLYER_REFERRER);
                shouldInitAppsflyer = !referrer;
              }

              if (shouldInitAppsflyer) {
                // return
                if (!_DeviceInfoHelper["default"].isBrowser() && window.plugins && window.plugins.appsFlyer) {
                  options = {
                    devKey: _config["default"].appsflyerDevKey,
                    // your AppsFlyer devKey
                    isDebug: _BuildConstants.NODE_ENV !== 'production',
                    onInstallConversionDataListener: true
                  };

                  if (_DeviceInfoHelper["default"].isiOS() && _config["default"].appflyeriOSId) {
                    options.appId = _config["default"].appflyeriOSId; // your ios app id in app store
                  }

                  window.plugins.appsFlyer.initSdk(options, function (result) {
                    console.log('successfully initialized appsflyer', result);
                    var jsonResult = JSON.parse(result);
                    console.log('appsflyer', jsonResult);

                    if (jsonResult.data) {
                      if (jsonResult.data.ds) {
                        // save to dataStore
                        var data = JSON.parse(jsonResult.data.ds);

                        if (data) {
                          _DataStore["default"].setData(data).then(function () {});
                        }
                      }

                      var _referrer = 'n/a';

                      if (jsonResult.data.link) {
                        var link = jsonResult.data.link.split('referrer=');

                        if (link.length > 0) {
                          console.log('appsflyer', link[1]);

                          _this.setState({
                            deepLinkChecked: true
                          });
                        }

                        _referrer = link[1];
                      }

                      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.APPSFLYER_REFERRER, _referrer);
                    }
                  }, function (error) {
                    console.error('error initializing appsflyer', error);

                    _this.setState({
                      deepLinkChecked: true
                    });
                  });
                }
              }

              _this.setState({
                deepLinkChecked: true
              });

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOnline", function () {
      // TODO: check if current device is still the last used one
      // TODO: check if we need this for browsers, i suspect every call will be doubled...
      if (_DeviceInfoHelper["default"].isBrowser()) {
        if (_config["default"].useWebLogin) {
          // check list states
          _this.checkListStates();
        }

        return;
      }

      console.log('app online');

      var path = _NavigationManagerCordova["default"].getCurrentPath();

      if (path) {
        var id = _NavigationManagerCordova["default"].getCurrentId();

        var scrollTop = _NavigationManagerCordova["default"].getScrollTop();

        (0, _LogService["default"])(id, path);

        if ((0, _KESI2Helper.isRemoteControllingEnabledWhenOnline)()) {
          (0, _index.pushNavigateMessage)(id, path, scrollTop);
        }
      }

      console.log('register for app channel online');
      (0, _AppChannel.register)(_this.onMessageForThisApp, 'AppCordova');

      if (!_this.state.registeredAsSlave) {
        _this.setState({
          registeredAsSlave: true
        });

        (0, _RemoteControlledService.register)(_this.onMessageForSlave);
      }

      if (_config["default"].loadVisibilities) {
        _KESI2Helper["default"].getVisibilities();
      } // if (target.isSafetureApp) {
      // get the data store from the server and check for push messages


      _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.SERVER, true, function () {
        (0, _SysMessageHelper.handleSysMessages)((0, _assertThisInitialized2["default"])(_this));
      }); // }


      if (_config["default"].usesAnalyzer) {
        _RelevancesService["default"].updateFromServer();
      }

      if (_config["default"].useWebLogin) {
        // check list states
        _this.checkListStates();
      } else if (!_config["default"].isSafetureApp) {
        console.log('retrieve loadFromServer onOnline');

        _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.PUBLIC);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTargetSpecificSysMessage", /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(message) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDenyPrivacyAgreement", function () {
      _this.showingPrivacyDialog = false;

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED, false);

      (0, _LogService.pushTravelAndCareLogMessage)('privacy_denied');
      var okButton = {
        label: (0, _strings2.getString)('OK'),
        callback: _this.showPrivacyDialogIfNecessary
      };
      (0, _MuiAlertHelper.showAlert)((0, _strings2.getString)('TC_PLEASE_ACCEPT_PRIVACY_AGREEMENT_AFTER_DENY'), (0, _strings2.getString)('TC_PRIVACY_AGREEMENT'), false, [okButton]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showPrivacyAgreement", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
      var homeRegionCode, flexUrls;
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              homeRegionCode = _this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];

              if (!homeRegionCode) {
                _context10.next = 7;
                break;
              }

              _context10.next = 4;
              return (0, _FlexMenuHelper.getFlexUrls)(homeRegionCode);

            case 4:
              flexUrls = _context10.sent;
              window.open(flexUrls.privacy, '_system');

              _this.showPrivacyDialogIfNecessary();

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showPrivacyDialogIfNecessary", function () {
      // might be called twice if the close dialog button of the region chooser is tapped twice
      if (_this.showingPrivacyDialog) {
        return;
      }

      _this.showingPrivacyDialog = true;

      if (_config["default"].isSafetureApp) {
        var alreadyAccepted = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED);

        if (!alreadyAccepted) {
          // const acceptCheckbox = {
          //   label: getString('I_ACCEPT_THE_PRIVACY_AGREEMENT'),
          //   onLabelClick: this.changeUserPrivacyAgreement,
          //   onChange: this.changeUserPrivacyAgreement,
          //   ripple: true,
          //   ref: 'tc_privacy_checkbox',
          //   className: 'kesiCheckBox',
          //   checked: () => { return this.tc_privacy_accepted === true }
          // }
          var denyButton = {
            label: (0, _strings2.getString)('DENY'),
            callback: _this.onDenyPrivacyAgreement
          };
          var acceptButton = {
            label: (0, _strings2.getString)('TC_PRIVACY_ACCEPT'),
            callback: _this.onAcceptPrivacyAgreement,
            className: _AppCordovaGeneric["default"].bold
          };

          var message = /*#__PURE__*/_react["default"].createElement("div", null, (0, _strings2.getString)('TC_PRIVACY_AGREEMENT_MESSAGE'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              textDecoration: 'underline',
              fontSize: 14
            },
            onClick: function onClick() {
              _this.showPrivacyAgreement();
            }
          }, (0, _strings2.getString)('OPEN_PRIVACY_AGREEMENT')), /*#__PURE__*/_react["default"].createElement("br", null), (0, _strings2.getString)('I_ACCEPT_THE_PRIVACY_AGREEMENT'));

          _this.privacyDialogCloseOrUpdateFn = (0, _MuiAlertHelper.showWideAlertReact)(message, '[React alert] privacy agreement dialog with TC_PRIVACY_AGREEMENT_MESSAGE', (0, _strings2.getString)('TC_PRIVACY_AGREEMENT'), false, [denyButton, acceptButton], true);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkUrl", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
      var id, lang, search;
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              id = null;
              lang = null;

              if (!_DeviceInfoHelper["default"].isBrowser()) {
                _context11.next = 14;
                break;
              }

              search = window.location.search;
              id = search.replace(/(.*id=)([^&]+)(.*)/, '$2');
              lang = search.replace(/(.*lang=)([^&]+)(.*)/, '$2');
              if (id === search) id = null;
              if (lang === search) lang = null; // TODO language koorekt auswerten um den content passend zu holen

              if (lang === null) lang = 'de';
              _context11.next = 11;
              return (0, _strings.setCurrentLanguage)(lang);

            case 11:
              _context11.next = 13;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE, lang);

            case 13:
              console.log('checkUrl', search, id, lang);

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkListStates", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
      var response, featureState;
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (_config["default"].useWebLogin) {
                _context12.next = 2;
                break;
              }

              return _context12.abrupt("return");

            case 2:
              _context12.next = 4;
              return _UserManagementService["default"].checkListStates(true);

            case 4:
              response = _context12.sent;
              console.log('checkListStates response', response);

              if (response.features && response.features.length > 0) {
                featureState = response.features[0].state;

                if (_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) && featureState === 'PIN_LOCKED') {
                  console.log('logged in and listStates returned PIN_LOCKED');
                  (0, _CordovaHelper.logOut)(true, null, false, 'AppCordovaGeneric checkListStates pinLocked');
                }
              }

            case 7:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideIncidentView", function () {
      if (_this.state.currentIncidentByPush) {
        _this.setState({
          currentIncidentByPush: null
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "registerForNotifications", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
      var token;
      return _regenerator["default"].wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              console.log('registerForNotifications1');

              if (_DeviceInfoHelper["default"].isBrowser()) {
                _context16.next = 22;
                break;
              }

              console.log('registerForNotifications2', window.FCM);

              if (!(!window.FCMPlugin && !window.FCM)) {
                _context16.next = 6;
                break;
              }

              if (_config["default"].isSafetureApp) {
                (0, _MuiAlertHelper.showAlertInDebugMode)((0, _strings2.getString)('PUSH_NOTIFICATION_ERROR_MSG'), (0, _strings2.getString)('PUSH_NOTIFICATION_ERROR'));
              }

              return _context16.abrupt("return");

            case 6:
              if (!window.FCMPlugin) {
                _context16.next = 12;
                break;
              }

              window.FCMPlugin.onTokenRefresh( /*#__PURE__*/function () {
                var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(token) {
                  return _regenerator["default"].wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          console.log('fcm token was refreshed', token);

                          if (!(!token || token === '(null)' || token === 'BLACKLISTED' || token === 'null')) {
                            _context13.next = 3;
                            break;
                          }

                          return _context13.abrupt("return");

                        case 3:
                          if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FCM_TOKEN) !== token) {
                            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FCM_TOKEN, token);
                          }

                        case 4:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13);
                }));

                return function (_x4) {
                  return _ref14.apply(this, arguments);
                };
              }());
              window.FCMPlugin.getToken( /*#__PURE__*/function () {
                var _ref15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(token) {
                  return _regenerator["default"].wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          console.log('got fcm token', token);

                          if (!(!token || token === '(null)' || token === 'BLACKLISTED' || token === 'null')) {
                            _context14.next = 3;
                            break;
                          }

                          return _context14.abrupt("return");

                        case 3:
                          if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FCM_TOKEN) !== token) {
                            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FCM_TOKEN, token);
                          }

                        case 4:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14);
                }));

                return function (_x5) {
                  return _ref15.apply(this, arguments);
                };
              }());
              window.FCMPlugin.onNotification(function (data) {
                _this.onNotificationReceived(data);
              });
              _context16.next = 22;
              break;

            case 12:
              if (!window.FCM) {
                _context16.next = 22;
                break;
              }

              console.log('registerForNotifications3', window.FCM.onTokenRefresh, window.FCM.getToken);
              window.FCM.onTokenRefresh( /*#__PURE__*/function () {
                var _ref16 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(token) {
                  return _regenerator["default"].wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          console.log('registerForNotifications4');
                          console.log('fcm token was refreshed', token);

                          if (!(!token || token === '(null)' || token === 'BLACKLISTED' || token === 'null')) {
                            _context15.next = 4;
                            break;
                          }

                          return _context15.abrupt("return");

                        case 4:
                          console.log('registerForNotifications5');

                          if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FCM_TOKEN) !== token) {
                            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FCM_TOKEN, token);
                          }

                          console.log('registerForNotifications6');

                        case 7:
                        case "end":
                          return _context15.stop();
                      }
                    }
                  }, _callee15);
                }));

                return function (_x6) {
                  return _ref16.apply(this, arguments);
                };
              }());
              _context16.next = 17;
              return window.FCM.getToken();

            case 17:
              token = _context16.sent;

              if (!(!token || token === '(null)' || token === 'BLACKLISTED' || token === 'null')) {
                _context16.next = 20;
                break;
              }

              return _context16.abrupt("return");

            case 20:
              if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FCM_TOKEN) !== token) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FCM_TOKEN, token);
              }

              window.FCM.onNotification(function (data) {
                _this.onNotificationReceived(data);
              });

            case 22:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setMenuOpen", function (menuOpen) {
      _this.setState({
        menuOpen: menuOpen
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMessageForSlave", /*#__PURE__*/function () {
      var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(message) {
        var currentPath, currentPathArray, newPath, _newPath;

        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                console.log('message for slave arrived', message);

                if (!(_config["default"].isKesiSlave && !(0, _KESI2Helper.isKesiMaster)())) {
                  _context17.next = 28;
                  break;
                }

                if (!(message.name === 'navigateTo')) {
                  _context17.next = 25;
                  break;
                }

                if (!(message.data.path && message.data.path.length > 0)) {
                  _context17.next = 18;
                  break;
                }

                currentPath = "".concat(_KesiConstants.KESI_PATH_DELIMITER).concat(_NavigationManagerCordova["default"].getCurrentPath());
                currentPathArray = currentPath.split(_KesiConstants.KESI_PATH_DELIMITER);

                if (!(currentPathArray && currentPathArray.length > 0 && currentPathArray[currentPathArray.length - 1] === 'settings')) {
                  _context17.next = 15;
                  break;
                }

                _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl());

                _context17.next = 10;
                return (0, _TimeoutHelper.timeout)(500);

              case 10:
                newPath = message.data.path.substring(1).startsWith(_config["default"].baseRoute) ? message.data.path.substring(1) : "".concat(_config["default"].baseRoute, "/").concat(message.data.path.substring(1));
                _context17.next = 13;
                return _NavigationManagerCordova["default"].goTo(newPath);

              case 13:
                _context17.next = 18;
                break;

              case 15:
                _newPath = message.data.path.substring(1).startsWith(_config["default"].baseRoute) ? message.data.path.substring(1) : "".concat(_config["default"].baseRoute, "/").concat(message.data.path.substring(1));
                _context17.next = 18;
                return _NavigationManagerCordova["default"].goTo(_newPath);

              case 18:
                if (!(window.screen.orientation && message.data.screenOrientation)) {
                  _context17.next = 24;
                  break;
                }

                window.screen.orientation.lock(message.data.screenOrientation);
                _context17.next = 22;
                return (0, _TimeoutHelper.timeout)(800);

              case 22:
                // force update after rotation animation
                _this.forceUpdate();

                setTimeout(function () {
                  window.screen.orientation.unlock();
                }, SCREEN_ORIENTATION_LOCK_TIMEOUT);

              case 24:
                if (message.data.id && (message.data.scrollPosition || message.data.scrollPosition === 0)) {
                  console.log(remoteScrollCallbacks);
                  remoteScrollCallbacks[message.data.id](message.data.scrollPosition);
                }

              case 25:
                if (message.name === 'activate' && message.data && message.data.state) {
                  _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES), message.data.state);
                }

                _context17.next = 29;
                break;

              case 28:
                if (message.name === 'activate' && message.data && message.data.state) {
                  _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES), message.data.state);
                }

              case 29:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x7) {
        return _ref17.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "animateMessage", /*#__PURE__*/function () {
      var _ref18 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(ablyChannel) {
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x8) {
        return _ref18.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMessageForThisApp", function (message) {
      var channelName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      console.log('AppCordovaGeneric.js - message for this device arrived', message);
      var isAlertMessage = (0, _AlertHelper.showAlertFromNotification)(message);

      if (isAlertMessage) {
        return;
      }

      var command = message.name;
      console.log('AppCordovaGeneric.js - message for this device arrived', command, command === 'liveTickerMessage');

      var handledByTarget = _this.handleTargetSpecificAblyMessage(message, channelName);

      if (handledByTarget) {
        return;
      }

      if (command === _AblyMessagingCommands.ABLY_COMMANDS.REORDER && message.data) {
        _RelevancesActions["default"].setRelevances(message.data);
      } else if (command === _AblyMessagingCommands.ABLY_COMMANDS.LOGGED_OUT && _config["default"].useWebLogin) {
        console.log('ably message with event loggedout', message.data);
        (0, _CordovaHelper.logOut)(false, null, false, 'AppCordovaGeneric Ably logOutCommand');
        (0, _AlertHelper.showAlertWithOptions)({
          html: message.data.message ? message.data.message : (0, _strings2.getString)('MUST_LOG_IN'),
          title: (0, _strings2.getString)('AUTOMATIC_LOGOUT'),
          centeredContent: true,
          showCloseButton: false,
          buttons: [{
            label: 'OK',
            callback: function () {
              var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
                return _regenerator["default"].wrap(function _callee19$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        window.location.reload();

                      case 1:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee19);
              }));

              function callback() {
                return _callback.apply(this, arguments);
              }

              return callback;
            }()
          }]
        }); // showWideAlertHtml(message.data.message ? message.data.message : getString('MUST_LOG_IN'), getString('AUTOMATIC_LOGOUT'), false, [
        //   {
        //     label: 'OK',
        //     callback: async () => {
        //       window.location.reload()
        //     }
        //   }
        // ])
      } else if (command === 'message') {
        console.log('chat message received', message, channelName);

        var messages = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES);

        if (messages[channelName] && messages[channelName].length > 0) {
          messages[channelName].push(message.data);
        } else {
          messages[channelName] = [message.data];
        }

        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_MESSAGES, ".").concat(channelName), messages[channelName]);

        var path = null;

        var channels = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.CHAT_CHANNELS);

        var chatChannel = channels.find(function (chat) {
          return chat.channelName === channelName;
        });
        console.log('chat message, path', chatChannel);

        if (chatChannel) {
          path = chatChannel.path;
        }

        console.log('chat message, path', path);

        var inChat = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.IN_CHAT);

        console.log('chat message, inChat', inChat);

        if (inChat !== true) {
          (0, _SnackbarHelper.showSnackbarMessage)( /*#__PURE__*/_react["default"].createElement("div", null, "Es gibt eine neue Nachricht im Expertenchat von ", message.data.userName, "!", ' ', path ? /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              textDecoration: 'underline',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              _NavigationManagerCordova["default"].goTo(path);
            }
          }, "Zum Chat") : null));
        }
      } else if (command === 'liveTickerMessage') {
        console.log('liveticker message received', message, channelName);

        var _messages = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LIVETICKER_MESSAGES);

        if (!_messages) {
          _messages = [];
        }

        if (_messages[channelName] && _messages[channelName].length > 0) {
          var messageToStore = message.data; // messageToStore.isHidden = true

          _messages[channelName].push(messageToStore);
        } else {
          var _messageToStore = message.data; // messageToStore.isHidden = true

          _messages[channelName] = [_messageToStore];
        } // this.animateMessage(channelName)


        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.LIVETICKER_MESSAGES, ".").concat(channelName), _messages[channelName], false);

        var _path = null;

        var _channels = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LIVETICKER_CHANNELS);

        var _chatChannel = _channels.find(function (chat) {
          return chat.channelName === channelName;
        });

        console.log('liveTickerMessage message, path', _chatChannel);

        if (_chatChannel) {
          _path = _chatChannel.path;
        }

        var inFeedback = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.IN_LIVE_TICKER);

        if (inFeedback !== true) {
          (0, _SnackbarHelper.showSnackbarMessage)( /*#__PURE__*/_react["default"].createElement("div", null, "Es gibt eine neue Nachricht im Liveticker!", ' ', _path ? /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              textDecoration: 'underline',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              _NavigationManagerCordova["default"].goTo(_path);
            }
          }, "Zum Liveticker") : null));
        }
      } else if (command === 'expertStatusChange') {
        console.log('expert changed his status -> set status', message.data.chatStatus);

        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_STATUS, ".").concat(channelName), message.data.chatStatus);

        if (message.data.chatStatus === _Chat.CHAT_STATUS.FINISHED) {
          console.log('setting chatStatus to finished');

          _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, ".").concat(channelName), true);
        }
      } else if (command === _AblyMessagingCommands.ABLY_COMMANDS.ALLOW_PASSWORD_RESET) {// is handled directly by KesiLogin
      } else if (command === _AblyMessagingCommands.ABLY_COMMANDS.CANCEL_CONNECTION || command === _AblyMessagingCommands.ABLY_COMMANDS.CONFIRM_CONNECTION || command === _AblyMessagingCommands.ABLY_COMMANDS.PARTNER_ACTIVE) {
        if (message.data) {
          (0, _AppUtils.callListenersForAblyMessageWithcommand)(command, message);
        }
      } else if (command === _AblyMessagingCommands.ABLY_COMMANDS.FEEDBACK_TAGS) {
        // Todo: What if question has a tag but this kesi doesnt have the content required?
        (0, _AppChannel.sendMessage)(_AblyMessagingCommands.ABLY_COMMANDS.FEEDBACK_TAGS_RECEIVED, {}, message.clientId);
        console.log('Received feedback tags');

        if (message.data && message.data.tags) {
          var _path2 = _KESI2Helper["default"].getContentByTagname(message.data.tags);

          if (_path2 && _path2.length >= 5) {
            // todo: what if we just want to navigate to a spoc maybe? resulting in a shorter path
            var newHash = "".concat(_config["default"].baseRoute, "/").concat(_path2[0], "!").concat(_path2[1], "!").concat(_path2[2], "?nugget=").concat(_path2[3], "&action=").concat(_path2[4]); // preventing an error message, that we cant push the same url twice

            if (window.location.hash !== '#/' + newHash) {
              _NavigationManagerCordova["default"].goTo(newHash);
            }
          }
        }
      } else if (command === _AblyMessagingCommands.ABLY_COMMANDS.SYS_MESSAGES) {
        (0, _SysMessageHelper.handleSysMessages)((0, _assertThisInitialized2["default"])(_this), message.data);
      } else {
        _DataStoreAblyHelper["default"].handleAblyMessage(message);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOrientationChange", function () {
      if ((0, _KESI2Helper.isRemoteControllingEnabled)()) {
        // orientation is set in pushNavigateMessage, but we have to send a message
        var path = _NavigationManagerCordova["default"].getCurrentPath();

        var id = _NavigationManagerCordova["default"].getCurrentId();

        var scrollTop = _NavigationManagerCordova["default"].getScrollTop();

        (0, _index.pushNavigateMessage)(id, path, scrollTop);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "initStores", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
      return _regenerator["default"].wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              console.log('reading local data');
              _context20.prev = 1;
              console.log('uses analyzer:', _config["default"].usesAnalyzer);
              _context20.next = 5;
              return _DataStore["default"].loadFromNativeStorage();

            case 5:
              _context20.next = 7;
              return _LogStore["default"].loadFromNativeStorage();

            case 7:
              _context20.next = 9;
              return _DataMigrator["default"].migrate();

            case 9:
              (0, _LogService.loggingAvailable)();

              if (!_config["default"].usesAnalyzer) {
                _context20.next = 13;
                break;
              }

              _context20.next = 13;
              return _RelevancesService["default"].init();

            case 13:
              _this.setState({
                storeInitialized: true
              });

              return _context20.abrupt("return", _promise["default"].resolve());

            case 17:
              _context20.prev = 17;
              _context20.t0 = _context20["catch"](1);

              _this.initStores();

              return _context20.abrupt("return", _promise["default"].reject(_context20.t0));

            case 21:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, null, [[1, 17]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setScrollBarHidden", function (scrollBarHidden) {
      _this.setState({
        scrollBarHidden: scrollBarHidden
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setTitle", function (title) {
      if (title !== _this.state.title) {
        _this.setState({
          title: title
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setUsageCount", /*#__PURE__*/function () {
      var _ref20 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(count) {
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(_this.state.count !== count)) {
                  _context21.next = 4;
                  break;
                }

                _context21.next = 3;
                return (0, _TimeoutHelper.timeout)();

              case 3:
                _this.setState({
                  count: count
                });

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x9) {
        return _ref20.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeCountryChooser", function () {
      _this.setState({
        forceCountryDialog: false
      });

      _this.showPrivacyDialogIfNecessary();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onContentLoaded", /*#__PURE__*/function () {
      var _ref21 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(didCompleteReload) {
        var innerOnOnline;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (navigator.splashscreen && !_config["default"].useSplashScreenToHideLoading) {
                  setTimeout(function () {
                    navigator.splashscreen.hide();
                  }, 300);
                }

                if (!didCompleteReload) {
                  // check for content update at start
                  if (_DeviceInfoHelper["default"].isOnline()) {
                    // Comment out for ERGO TESTING
                    _this.updateContent(true, false, null, false);
                  } else {
                    innerOnOnline = function innerOnOnline() {
                      _DeviceInfoHelper["default"].removeOnlineListener(innerOnOnline); // Comment out for ERGO TESTING


                      _this.updateContent(true, false, null, false);
                    };

                    _DeviceInfoHelper["default"].addOnlineListener(innerOnOnline);
                  }
                } else if (_this.pathToGoAfterContentLoad) {
                  _NavigationManagerCordova["default"].goTo(_this.pathToGoAfterContentLoad);
                }

                if (_config["default"].usesChatNuggets) {
                  _this.connectToChatChannels();
                }

                if (_config["default"].usesLiveTickerNuggets) {
                  _this.connectToLiveTickerChannels();
                }

                _this.connectToTargetChannels();

                _this.connectToTargetChannelPresences();

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x10) {
        return _ref21.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
      var isInitialLoad,
          precompiledDataAvailable,
          appHasBeenStartedBefore,
          promises,
          didCompleteReload,
          results,
          feature,
          userAuth,
          userId,
          hasAlert,
          retryButton,
          exitButton,
          okButton,
          _args23 = arguments;
      return _regenerator["default"].wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              isInitialLoad = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : true;

              if (!_this.loadContentLock) {
                _context23.next = 4;
                break;
              }

              console.warn('other loading process in progress');
              return _context23.abrupt("return", _promise["default"].reject(new Error('other loading process in progress')));

            case 4:
              _this.loadContentLock = true;

              _this.setState({
                downloadProgressText: _DeviceInfoHelper["default"].isBrowser() ? (0, _strings2.getString)('INIT_OR_WAIT_FOR_SERVER') : (0, _strings2.getString)('UPDATE_CHECK'),
                downloadProgress: 0
              });

              _context23.next = 8;
              return _CordovaFileHelper["default"].initFolderNames();

            case 8:
              precompiledDataAvailable = false;
              _context23.next = 11;
              return _CordovaFileHelper["default"].folderExists(_CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

            case 11:
              appHasBeenStartedBefore = _context23.sent;

              if (appHasBeenStartedBefore) {
                _context23.next = 16;
                break;
              }

              _context23.next = 15;
              return _KESI2Helper["default"].unpackCompiledDataFile(_this.setProgress);

            case 15:
              precompiledDataAvailable = _context23.sent;

            case 16:
              promises = [_KESI2Helper["default"].init(_this.onProgress, false, precompiledDataAvailable)];
              _this.spinnerStartTime = (0, _now["default"])();
              didCompleteReload = false;
              _context23.prev = 19;
              _context23.next = 22;
              return _promise["default"].all(promises);

            case 22:
              results = _context23.sent;

              if (results && results.length > 0) {
                didCompleteReload = results[0];
              }

              _context23.next = 26;
              return (0, _strings.reloadStrings)();

            case 26:
              if (_config["default"].useSettingsDialog && !_DataStore["default"].pathExists(_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE)) {
                _this.setState({
                  forceCountryDialog: true
                });
              } else {
                _this.showPrivacyDialogIfNecessary();
              }

              feature = _FeatureManager["default"].getFeature('equeoqd');

              if (!_config["default"].useDrupalContent) {
                _context23.next = 36;
                break;
              }

              _context23.t1 = "Bearer ";
              _context23.next = 32;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 32:
              _context23.t2 = _context23.sent;
              _context23.t0 = _context23.t1.concat.call(_context23.t1, _context23.t2);
              _context23.next = 37;
              break;

            case 36:
              _context23.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

            case 37:
              userAuth = _context23.t0;

              if (userAuth && feature && feature.userId) {
                userId = feature.userId;

                _EquizzerActions["default"].setUserAuth({
                  id: userId,
                  _auth: userAuth
                });
              }

              if (!_config["default"].isSafetureApp) {
                _context23.next = 44;
                break;
              }

              hasAlert = _this.showWelcomeAlert();

              if (!hasAlert) {
                _context23.next = 44;
                break;
              }

              _context23.next = 44;
              return (0, _TimeoutHelper.timeout)(500);

            case 44:
              console.log('done parsing content');

              _this.setState({
                loading: false,
                currentUpdateValue: _this.state.currentUpdateValue + 1,
                // eslint-disable-line no-magic-numbers
                contentLoadedAtStart: true
              });

              _this.setProgress(_DeviceInfoHelper["default"].isBrowser() ? (0, _strings2.getString)('INIT_OR_WAIT_FOR_SERVER') : (0, _strings2.getString)('UPDATE_CHECK'), 0);

              _this.loadContentLock = false;

              if (_this.pathToGoAfterContentLoad) {
                setTimeout(function () {
                  _NavigationManagerCordova["default"].goTo(_this.pathToGoAfterContentLoad);

                  _this.pathToGoAfterContentLoad = null;
                }, 300);
              }

              _this.onContentLoaded();

              if (navigator.splashscreen && _config["default"].useSplashScreenToHideLoading) {
                console.log('hide splash on content loaded');
                setTimeout(function () {
                  navigator.splashscreen.hide();
                }, 500);
              }

              return _context23.abrupt("return", _promise["default"].resolve(didCompleteReload));

            case 54:
              _context23.prev = 54;
              _context23.t3 = _context23["catch"](19);

              if (window.navigator.splashscreen) {
                console.log('hide splash on error');
                navigator.splashscreen.hide();
              }

              if (!isInitialLoad) {
                _this.setState({
                  loading: false
                });
              }

              retryButton = {
                label: (0, _strings2.getString)('TRY_AGAIN'),
                callback: function callback() {
                  try {
                    _this.loadContent(isInitialLoad);
                  } catch (error) {
                    console.error('AppCordova.loadContent retry', error);
                  }
                }
              };

              if (isInitialLoad) {
                if (_DeviceInfoHelper["default"].isAndroid()) {
                  exitButton = {
                    label: (0, _strings2.getString)('QUIT_APP'),
                    callback: window.navigator.app.exitApp // not available on iOS

                  };
                  (0, _AlertHelper.showAlertWithOptions)({
                    message: (0, _strings2.getString)('ERROR_LOADING_CONTENT'),
                    title: (0, _strings2.getString)('ERROR'),
                    showCloseButton: false,
                    buttons: [retryButton, exitButton]
                  }); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'), false, [retryButton, exitButton])
                } else {
                  (0, _AlertHelper.showAlertWithOptions)({
                    message: (0, _strings2.getString)('ERROR_LOADING_CONTENT'),
                    title: (0, _strings2.getString)('ERROR'),
                    showCloseButton: false,
                    buttons: [retryButton]
                  }); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'), false, [retryButton])
                }
              } else {
                okButton = {
                  label: (0, _strings2.getString)('OK'),
                  callback: function callback() {}
                };
                (0, _AlertHelper.showAlertWithOptions)({
                  message: (0, _strings2.getString)('ERROR_LOADING_CONTENT'),
                  title: (0, _strings2.getString)('ERROR'),
                  showCloseButton: false,
                  buttons: [retryButton, okButton]
                }); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'), false, [retryButton, {
                //   label: getString('OK'),
                //   callback: () => {}
                // }])
              }

              _this.loadContentLock = false;
              return _context23.abrupt("return", _promise["default"].resolve());

            case 62:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, null, [[19, 54]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openMenu", function () {
      _this.setState({
        menuOpen: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setBodyPositionFixed", function (trueOrFalse) {
      window.document.body.style.position = trueOrFalse ? 'absolute' : 'inherit';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setProgress", function (progressText, progress) {
      var ignoreTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      console.log('setProgress', progressText, progress, ignoreTimeout);
      _this.nextDownloadProgressToSet = progress;

      if (ignoreTimeout) {
        _this.setState({
          downloadProgress: _this.nextDownloadProgressToSet,
          downloadProgressText: progressText
        });
      } else {
        if (!_this.progressTimeout) {
          _this.progressTimeout = setTimeout(function () {
            _this.setState({
              downloadProgress: _this.nextDownloadProgressToSet,
              downloadProgressText: progressText
            });

            _this.progressTimeout = null;
          }, _this.state.downloadProgress <= 0 ? 0 : 200);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setBackButtonFunc", function (callback) {
      var pushToStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if ((0, _ArrayHelper.getLastElement)(_this.state.backButtonFunc) !== callback) {
        if (callback) {
          var backButtonFunc = pushToStack && _this.state.backButtonFunc ? _this.state.backButtonFunc.concat(callback) : [callback];

          _this.setState({
            showBackButton: backButtonFunc !== null,
            backButtonFunc: backButtonFunc
          });

          _NavigationManagerCordova["default"].setBackFunc(callback);

          return backButtonFunc;
        } else {
          _this.setState({
            showBackButton: false,
            backButtonFunc: null
          });

          _NavigationManagerCordova["default"].setBackFunc(null);

          return null;
        }
      }

      return _this.state.backButtonFunc;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goHome", function () {
      _this.setState({
        showBackButton: false
      });

      _NavigationManagerCordova["default"].goHome();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setShowFavButton", function (value) {
      _this.setState({
        showFavButton: value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reloadContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
      var goHome,
          _args24 = arguments;
      return _regenerator["default"].wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              goHome = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : true;

              _this.setState({
                loading: true
              });

              _context24.prev = 2;
              _context24.next = 5;
              return _KESI2Helper["default"].init(null, true);

            case 5:
              _this.setState({
                loading: false
              });

              if (!_config["default"].isSafetureApp) {
                _context24.next = 9;
                break;
              }

              _context24.next = 9;
              return (0, _strings.setCurrentLanguage)(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE).languageCode);

            case 9:
              if (goHome) {
                setTimeout(function () {
                  _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl(), null, true);
                });
              }

              if (navigator.splashscreen && _config["default"].useSplashScreenToHideLoading) {
                console.log('hide splash on reload content');
                navigator.splashscreen.hide();
              }

              return _context24.abrupt("return", _promise["default"].resolve());

            case 14:
              _context24.prev = 14;
              _context24.t0 = _context24["catch"](2);
              console.log('error reloading content', _context24.t0);
              (0, _AlertHelper.showAlertWithOptions)({
                message: (0, _strings2.getString)('ERROR_LOADING_CONTENT'),
                title: (0, _strings2.getString)('ERROR')
              }); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'))

              _this.setState({
                loading: false
              });

              return _context24.abrupt("return", _promise["default"].reject(_context24.t0));

            case 20:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, null, [[2, 14]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onProgress", function (progressEvent) {
      var downloadPhases = [(0, _strings2.getString)('DOWNLOADING'), (0, _strings2.getString)('UNZIPPING'), (0, _strings2.getString)('PARSING')];

      if (progressEvent.done) {
        _this.setProgress(null, 100);

        _this.progressTextIndex++;
      } // there should always be progressEvent.total but let's just be very sure because we have strange error reports from users


      if (progressEvent.total) {
        var loadingProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);

        _this.setProgress(downloadPhases[_this.progressTextIndex], loadingProgress);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reallyUpdateContent", /*#__PURE__*/function () {
      var _ref24 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(goHome) {
        var downloadBeforeShowingAlert,
            isUpdateFromUpdateContent,
            updated,
            _args26 = arguments;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                downloadBeforeShowingAlert = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : false;
                console.time('REALLY_UPDATE_CONTENT_COMPLETE');

                if (!downloadBeforeShowingAlert) {
                  _this.setState({
                    loading: true
                  });
                }

                _context26.prev = 3;
                // TODO: we need to find a better solution here in case someone has less than 5 spocs
                isUpdateFromUpdateContent = _config["default"].isErgoApp && _KESI2Helper["default"].getSpocCount() < 5; // this.setState({downloadProgressText: DeviceInfoHelper.isBrowser() ? getString('INIT_OR_WAIT_FOR_SERVER') : getString('UPDATE_CHECK'), downloadProgress: 0})
                // const updated = await KESI2Helper.update(this.onProgress, false, true, downloadBeforeShowingAlert)

                _context26.next = 7;
                return _KESI2Helper["default"].update(_this.setProgress, false, true, downloadBeforeShowingAlert);

              case 7:
                updated = _context26.sent;

                if (!updated) {
                  _context26.next = 16;
                  break;
                }

                if (!_config["default"].isSafetureApp) {
                  _context26.next = 12;
                  break;
                }

                _context26.next = 12;
                return (0, _strings.setCurrentLanguage)(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE));

              case 12:
                setTimeout(function () {
                  _this.setProgress((0, _strings2.getString)('UPDATE_DONE'), 100, true);

                  _this.setState({
                    loading: false
                  });
                }, 500);
                console.timeEnd('REALLY_UPDATE_CONTENT_COMPLETE');

                if (!_config["default"].updateContentWithoutAsking) {
                  setTimeout(function () {
                    (0, _SnackbarHelper.showSnackbarMessage)((0, _strings2.getString)('CONTENT_UPDATED_SNACKBAR'));
                  }, 2000);
                } // KESI2Helper.resetCachedProgressCompletely()
                // const updateValue = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0
                // setTimeout(() => {DataStore.setSingleData(DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1)}, 1000)


                if (goHome) {
                  if (_config["default"].forceHomeReload) {
                    _NavigationManagerCordova["default"].goHome(true);
                  }

                  if (!_config["default"].updateContentWithoutAsking) {
                    setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25() {
                      return _regenerator["default"].wrap(function _callee25$(_context25) {
                        while (1) {
                          switch (_context25.prev = _context25.next) {
                            case 0:
                              if (isUpdateFromUpdateContent) {
                                _NavigationManagerCordova["default"].goHome(true);
                              } else {
                                _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl(), null, true);
                              }

                            case 1:
                            case "end":
                              return _context25.stop();
                          }
                        }
                      }, _callee25);
                    })));
                  }
                }

              case 16:
                if (!updated || !goHome) {
                  _this.setState({
                    loading: false
                  });
                }

                _this.checkForDrupalLogin();

                return _context26.abrupt("return", updated);

              case 21:
                _context26.prev = 21;
                _context26.t0 = _context26["catch"](3);
                (0, _AlertHelper.showAlertWithOptions)({
                  message: (0, _strings2.getString)('ERROR_LOADING_CONTENT'),
                  title: (0, _strings2.getString)('ERROR')
                }); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'))

                _this.setState({
                  loading: false
                });

                return _context26.abrupt("return", _promise["default"].reject(_context26.t0));

              case 26:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[3, 21]]);
      }));

      return function (_x11) {
        return _ref24.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkForDelayedNavigatePush", function () {
      if (_this.pushToShowWhenUpdateIsDone) {
        if (_this.navigateToUpdateAlert) {
          _this.navigateToUpdateAlert();

          _this.navigateToUpdateAlert = null;
        }

        var data = _this.pushToShowWhenUpdateIsDone;

        _this.onNotificationReceived(data);

        _this.pushToShowWhenUpdateIsDone = null;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
      var goHome,
          updateWithoutFurtherDialog,
          onNoContentAvailableFn,
          onUserRequest,
          count,
          downloadBeforeShowingAlert,
          newCount,
          canShowSuccessSnackbar,
          updateAvailable,
          updateNowButton,
          updateLaterButton,
          _args28 = arguments;
      return _regenerator["default"].wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              goHome = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : true;
              updateWithoutFurtherDialog = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : true;
              onNoContentAvailableFn = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : null;
              onUserRequest = _args28.length > 3 && _args28[3] !== undefined ? _args28[3] : false;
              count = _args28.length > 4 && _args28[4] !== undefined ? _args28[4] : 10;
              // NavigationManagerCordova.goTo("/")
              downloadBeforeShowingAlert = _config["default"].downloadBeforeShowingAlert;

              if (_DeviceInfoHelper["default"].isOnline()) {
                _context28.next = 21;
                break;
              }

              if (!updateWithoutFurtherDialog) {
                _context28.next = 13;
                break;
              }

              if (_config["default"].isSafetureApp) {
                (0, _MuiAlertHelper.showAlert)((0, _strings2.getString)('SAFETURE_OFFLINE_MESSAGE'), (0, _strings2.getString)('SAFETURE_OFFLINE_TITLE'));
              } else {
                (0, _MuiAlertHelper.showAlert)((0, _strings2.getString)('ERROR_LOADING_CONTENT'), (0, _strings2.getString)('OFFLINE_TITLE'));
              }

              _this.updateInProgress = false;
              return _context28.abrupt("return");

            case 13:
              if (!(count > 0)) {
                _context28.next = 19;
                break;
              }

              console.log('offline while checking for new content with count ' + count);
              _context28.next = 17;
              return (0, _TimeoutHelper.timeout)(200);

            case 17:
              newCount = count - 1;
              return _context28.abrupt("return", _this.updateContent(goHome, updateWithoutFurtherDialog, onNoContentAvailableFn, onUserRequest, newCount));

            case 19:
              _this.updateInProgress = false;
              return _context28.abrupt("return", _promise["default"].reject(new Error("Device is offline, can't update content.")));

            case 21:
              if (!_this.updateInProgress) {
                _context28.next = 24;
                break;
              }

              if (onUserRequest) {
                (0, _SnackbarHelper.showSnackbarMessage)((0, _strings2.getString)('ALREADY_LOOKING_FOR_UPDATES'), true, true);
              }

              return _context28.abrupt("return");

            case 24:
              _this.updateInProgress = true;
              canShowSuccessSnackbar = true;

              if (updateWithoutFurtherDialog) {
                (0, _SnackbarHelper.showSnackbarMessageWithHourGlassButton)((0, _strings2.getString)('LOOKING_FOR_UPDATES'), false);
                /*
                canShowSuccessSnackbar = false
                setTimeout(() => {
                  canShowSuccessSnackbar = true
                }, 2000)
                 */
              }

              _context28.prev = 27;
              console.time('UPDATE_CONTENT_COMPLETE');
              _context28.prev = 29;

              _this.setState({
                showUpdateWindow: true
              });

              _this.setProgress((0, _strings2.getString)('UPDATE_CHECK'), 0, true);

              _context28.next = 34;
              return _KESI2Helper["default"].isUpdateAvailable();

            case 34:
              updateAvailable = _context28.sent;
              _context28.next = 47;
              break;

            case 37:
              _context28.prev = 37;
              _context28.t0 = _context28["catch"](29);
              console.log('error checking whether update is available', _context28.t0);
              (0, _SnackbarHelper.hideSnackbar)();

              if (onNoContentAvailableFn) {
                onNoContentAvailableFn();
              }

              if (updateWithoutFurtherDialog) {
                _this.setState({
                  loading: false
                });
              }

              _this.setProgress((0, _strings2.getString)('UPDATE_NO_UPDATE'), 100, true);

              setTimeout(function () {
                _this.setState({
                  showUpdateWindow: false,
                  updateCheckComplete: true
                });
              }, 1000);
              _this.updateInProgress = false;
              return _context28.abrupt("return");

            case 47:
              console.log('updateAvailable', updateAvailable);

              if (!updateAvailable) {
                _context28.next = 75;
                break;
              }

              if (!(downloadBeforeShowingAlert && !updateWithoutFurtherDialog)) {
                _context28.next = 57;
                break;
              }

              (0, _SnackbarHelper.hideSnackbar)();
              _context28.next = 53;
              return _this.reallyUpdateContent(goHome, downloadBeforeShowingAlert);

            case 53:
              setTimeout(function () {
                _this.setState({
                  showUpdateWindow: false
                });
              }, 2000);
              _this.updateInProgress = false;

              _this.checkForDelayedNavigatePush();

              return _context28.abrupt("return");

            case 57:
              if (!updateWithoutFurtherDialog) {
                _context28.next = 67;
                break;
              }

              _this.setState({
                loading: true
              });

              _this.setState({
                showUpdateWindow: false
              });

              (0, _SnackbarHelper.hideSnackbar)();
              _context28.next = 63;
              return _this.reallyUpdateContent();

            case 63:
              _this.updateInProgress = false;
              console.timeEnd('UPDATE_CONTENT_COMPLETE');

              _this.checkForDelayedNavigatePush();

              return _context28.abrupt("return");

            case 67:
              if (!(_this.lastUpdateAvailableDialogShown && (0, _now["default"])() - _this.lastUpdateAvailableDialogShown < MIN_TIME_BETWEEN_CONTENT_UPDATE_AVAILABLE_ALERTS)) {
                _context28.next = 69;
                break;
              }

              return _context28.abrupt("return");

            case 69:
              updateNowButton = {
                callback: function () {
                  var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27() {
                    return _regenerator["default"].wrap(function _callee27$(_context27) {
                      while (1) {
                        switch (_context27.prev = _context27.next) {
                          case 0:
                            _context27.next = 2;
                            return _this.reallyUpdateContent(goHome);

                          case 2:
                            _this.updateInProgress = false;
                            console.timeEnd('UPDATE_CONTENT_COMPLETE');

                            _this.setState({
                              showUpdateWindow: false
                            });

                          case 5:
                          case "end":
                            return _context27.stop();
                        }
                      }
                    }, _callee27);
                  }));

                  function callback() {
                    return _callback2.apply(this, arguments);
                  }

                  return callback;
                }(),
                label: (0, _strings2.getString)('UPDATE_NOW')
              };
              updateLaterButton = {
                callback: function callback() {
                  _this.setState({
                    showUpdateWindow: false
                  });
                },
                label: (0, _strings2.getString)('UPDATE_LATER')
              };
              (0, _MuiAlertHelper.showAlert)((0, _strings2.getString)('UPDATE_AVAILABLE'), (0, _strings2.getString)('UPDATE_AVAILABLE_TITLE'), true, [updateLaterButton, updateNowButton]);
              _this.lastUpdateAvailableDialogShown = (0, _now["default"])();
              _context28.next = 79;
              break;

            case 75:
              _this.setProgress((0, _strings2.getString)('UPDATE_NO_UPDATE'), 100, true);

              setTimeout(function () {
                _this.setState({
                  showUpdateWindow: false
                });
              }, 1000);

              if (onNoContentAvailableFn) {
                onNoContentAvailableFn();
              }

              if (updateWithoutFurtherDialog) {
                //          while (!canShowSuccessSnackbar) {
                //            await timeout(50)
                //          }
                if (canShowSuccessSnackbar) {
                  (0, _SnackbarHelper.showSnackbarMessage)((0, _strings2.getString)('NO_UPDATE_AVAILABLE_SNACKBAR'));
                }
              }

            case 79:
              if (updateWithoutFurtherDialog) {
                _this.setState({
                  loading: false
                });
              }

              _this.checkForDrupalLogin();

              _this.checkForDelayedNavigatePush();

              _this.setState({
                updateCheckComplete: true
              });

              _this.updateInProgress = false;
              _context28.next = 95;
              break;

            case 86:
              _context28.prev = 86;
              _context28.t1 = _context28["catch"](27);
              (0, _SnackbarHelper.hideSnackbar)();
              console.log('error updating content', _context28.t1); // showAlert(getString('ERROR_LOADING_CONTENT'), getString('ERROR'))

              _this.setState({
                loading: false
              });

              _this.setProgress((0, _strings2.getString)('UPDATE_NO_UPDATE'), 100, true);

              setTimeout(function () {
                _this.setState({
                  showUpdateWindow: false
                });
              }, 1000);
              _this.updateInProgress = false;
              return _context28.abrupt("return", _promise["default"].reject(_context28.t1));

            case 95:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28, null, [[27, 86], [29, 37]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderProgressBar", function () {
      if (isNaN(_this.state.downloadProgress)) {
        if (_this.state.downloadProgressText === 'Entpacken') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _AppCordovaGeneric["default"].progressBarContainer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _AppCordovaGeneric["default"].progressBar,
            style: {
              width: '100%'
            }
          }));
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _AppCordovaGeneric["default"].progressBarContainer
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].progressBarContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].progressBar,
        style: {
          width: "".concat(_this.state.downloadProgress, "%")
        }
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showSettingsDialog", function () {
      _this.setState({
        showSettingsDialog: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeSettingsDialog", function () {
      var changeRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        showSettingsDialog: false
      });

      if (changeRoute) {
        _NavigationManagerCordova["default"].goTo(_config["default"].cordovaStartUrl());
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showGlossary", function () {
      _this.setState({
        showGlossary: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeGlossary", function () {
      _this.setState({
        showGlossary: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setOpenTab", function (id) {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeIncidentView", function () {
      _this.setState({
        showCurrentIncidentByPush: false,
        backButtonFunc: _this.prevBackButtonFuncs,
        currentIncidentByPush: null
      });

      if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_TURNED_ON) && _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_AFTER_NEXT_PUSH_OPENED)) {
        setTimeout(function () {
          // don't wait
          (0, _AppUtils.askUserForAppRating)(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_OPTIONS)); // disable setting for the next time

          var data = {
            turnedOn: false,
            askAfterNextPushOpened: false,
            askOnNextTileClosing: false
          };

          _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_USER_RATING, data);
        }, 500);
      }

      _NavigationManagerCordova["default"].setBackFunc((0, _ArrayHelper.getLastElement)(_this.prevBackButtonFuncs));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPageScroll", function () {
      var pageScroll = document.getElementById(PAGE_SCROLL_ID);

      if (pageScroll) {
        var scrollTop = pageScroll.scrollTop;
        onPageScrollListeners.forEach(function (listener) {
          listener(scrollTop);
        });
      }
    });
    _this.state = {
      menuOpen: false,
      sidebarDocked: false,
      title: '',
      loading: true,
      contentLoadedAtStart: false,
      isLoadingContentAtStart: false,
      currentUpdateValue: 0,
      scrollBarHidden: false,
      downloadProgress: 0,
      downloadProgressText: (0, _strings2.getString)('INIT_OR_WAIT_FOR_SERVER'),
      backButtonFunc: [],
      showBackButton: false,
      showFavButton: false,
      registeredAsSlave: false,
      storeInitialized: false,
      deepLinkChecked: false,
      showSettingsDialog: false,
      showGlossary: false,
      forceCountryDialog: false,
      resetInProgress: false,
      dataStoreReady: false,
      endForcedLoading: false,
      currentIncidentByPush: null,
      showCurrentIncidentByPush: false,
      hardcodedLoginDone: false,
      // remove after the ITB
      showPrivacyAgreement: false,
      appUsable: true,
      deviceReady: false,
      hideBottomBar: !_config["default"].showBottomBar || _config["default"].showBottomBarOnlyInLecturesAndSpocs,
      renderUpdateValue: 0,
      animatedSplashscreenFinished: false,
      showUpdateWindow: false,
      updateCheckComplete: false
    }; // deviceReady must only be called once

    _this.deviceReadyCalled = false; // used for fullscreen incidents

    _this.prevBackButtonFuncs = null;
    _this.loadContentLock = false;
    _this.nextDownloadProgressToSet = null;
    _this.progressTimeout = null;
    _this.spinnerStartTime = null;
    _this.lastUpdateAvailableDialogShown = null;
    _this.privacyDialogCloseOrUpdateFn = null;
    _this.appSuspended = false;
    _this.appSuspendedCounter = 0;
    _this.showingPrivacyDialog = false;
    _this.pathToGoAfterContentLoad = null;
    _this.updateInProgress = false;
    _this.isUpdateAvailable = false;
    _this.canLoadContentOnlyFromDeviceReady = true;
    _this.alreadyInQRCodeScanner = false;
    _this.progressTextIndex = 0; // Alerts to show when we have a navigateTo but the content is not updated yet
    // first one is a notification to wait for the update

    _this.navigateToUpdateAlert = null; // second one is the push message with the link to the content

    _this.pushToShowWhenUpdateIsDone = null; // this.stores = [ContentStore, RelevancesStore, UsageStore, ThemeStore]
    // TODO: check if this line is really necessary
    // this.storeKeys = ['currentTheme', 'content', 'usage_initialized', 'usage_error', 'usages', 'relevances']

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(AppCordovaGeneric.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.SERVER, _DataStore.DATA_STORE_PATHS.LOGGED_IN, _DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED, _DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED, _DataStore.DATA_STORE_PATHS.VB_ACTIVATED]);
    (0, _AppUtils.setGlobalBackButtonFuncFunc)(_this.setBackButtonFunc);
    return _this;
  }

  (0, _createClass2["default"])(AppCordovaGeneric, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _strings.setOnLanguageChangedFn)(function () {
        return _this2.forceUpdate();
      });

      if (_config["default"].hasAnimatedSplashscreen) {
        this.playSplashScreenVideo();
      }

      document.addEventListener('deviceready', /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29() {
        return _regenerator["default"].wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!_config["default"].hasAnimatedSplashscreen) {
                  _context29.next = 3;
                  break;
                }

                _context29.next = 3;
                return (0, _TimeoutHelper.timeout)(500);

              case 3:
                // window.alert('Halt! Stop!')
                // For some reasons overwriting the function onDeviceReady does not work
                // TODO: find out why
                if (_this2.onDeviceReadyTarget) {
                  _this2.onDeviceReadyTarget();
                } else {
                  _this2.onDeviceReady();
                }

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      })), false);
      (0, _ResumeSuspendListeners.addOnSuspendListener)(this.onAppSuspend);
      (0, _ResumeSuspendListeners.addOnResumeListener)(this.onAppResume);
      this.addOnlineListener();

      if (!this.state.registeredAsSlave) {
        this.setState({
          registeredAsSlave: true
        });
        (0, _RemoteControlledService.register)(this.onMessageForSlave);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        // throw DeviceReady Event for Browser (wasn't working sometimes from loadCordova.js)
        var userAgent = window.navigator.userAgent;
        var ie10 = userAgent.indexOf('MSIE');
        var ie11 = userAgent.indexOf('rv:11');

        if (ie10 > 0 || ie11 > 0) {
          var deviceReady = document.createEvent('HTMLEvents');
          deviceReady.initEvent('deviceready', true, true);
          document.dispatchEvent(deviceReady);
        } else {
          document.dispatchEvent(new window.CustomEvent('deviceready'));
        }
      }

      if (_config["default"].androidBackButtonDisabled) {
        document.addEventListener('backbutton', function () {
          console.log('backButton disabled');
        }, false);
      }

      if (_DeviceInfoHelper["default"].isAndroid() && !_config["default"].androidBackButtonDisabled) {
        document.addEventListener('backbutton', this.onBackKeyDown, false);
      }
    }
    /*
    componentWillReceiveProps (nextProps) {
      const thisLocation = this.props.children.props.location.pathname.split('/')[0]
      const newLocation = nextProps.children.props.location.pathname.split('/')[0]
       if (thisLocation !== newLocation) {
        this.renderedChildren = null
        this.setState({
          renderUpdateValue: this.state.renderUpdateValue + 1
        })
      }
    }
    */

    /*
    async componentWillUpdate (newProps, newState) {
      if (!this.state.contentLoadedAtStart && DataStore.compare(DATA_STORE_PATHS.LOGGED_IN, true)) { // && DataStore.compare(DATA_STORE_PATHS.KESI_ACTIVE_DEVICE, RegisterInstance.getApplicationInstanceIdImmediately())) {
        try {
          await this.loadContent()
          if (target.usesChatNuggets) {
            this.connectToChatChannels()
          }
        }
        catch (error) {
          console.error('AppCordova.componentWillUpdate', error)
        }
      }
    }
    */

  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(prevProps, prevState, snapshot) {
        var thisLocation, newLocation;
        return _regenerator["default"].wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                thisLocation = prevProps.children.props.location.pathname.split('/')[0];
                newLocation = this.props.children.props.location.pathname.split('/')[0];

                if (thisLocation !== newLocation) {
                  this.renderedChildren = null;
                  this.setState({
                    renderUpdateValue: this.state.renderUpdateValue + 1
                  });
                }

                if (!(!this.canLoadContentOnlyFromDeviceReady && !prevState.contentLoadedAtStart && this.state.data[_DataStore.DATA_STORE_PATHS.LOGGED_IN] === true && !this.loadContentLock)) {
                  _context30.next = 14;
                  break;
                }

                _context30.prev = 4;
                _context30.next = 7;
                return this.loadContent();

              case 7:
                _context30.next = 9;
                return this.checkForDrupalLogin();

              case 9:
                _context30.next = 14;
                break;

              case 11:
                _context30.prev = 11;
                _context30.t0 = _context30["catch"](4);
                console.error('AppCordovaGeneric.componentWillUpdate', _context30.t0);

              case 14:
                if (this.state.currentUpdateValue !== prevState.currentUpdateValue || this.props.children !== prevProps.children) {
                  this.prerenderChildren();
                }

                if (this.isUpdateAvailable && prevState.showBackButton && !this.state.showBackButton) {
                  // update available and coming back to top level view
                  this.isUpdateAvailable = false;
                  this.updateContent(true, false, null, false);
                }

              case 16:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this, [[4, 11]]);
      }));

      function componentDidUpdate(_x12, _x13, _x14) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.onOrientationChange);
      }

      (0, _ResumeSuspendListeners.removeOnResumeListener)(this.onAppResume);
      (0, _ResumeSuspendListeners.removeOnSuspendListener)(this.onAppSuspend);

      _DeviceInfoHelper["default"].removeOnlineListener(this.onOnline);

      document.removeEventListener('backButton', _NavigationManagerCordova["default"].goBack);
      document.removeEventListener('backbutton', _NavigationManagerCordova["default"].goBackButButtonDisabled);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(AppCordovaGeneric.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "showAnimatedSplashscreen",
    value: function showAnimatedSplashscreen() {
      if (_config["default"].hasAnimatedSplashscreen) {
        console.log('showing animated splashscreen', _config["default"].hasAnimatedSplashscreen, 'TARGET_SPLASHSCREEN'); // console.log('animated splashscreen is', require('TARGET_SPLASHSCREEN'))
      }
    }
  }, {
    key: "checkUrlParams",
    value: function () {
      var _checkUrlParams = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32() {
        var _this3 = this;

        var urlParams, loggedIn, messageId, checkCampaignId, basePath, startUrl;
        return _regenerator["default"].wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                // check if start url is given
                urlParams = _UrlHelper["default"].getUrlParams();

                if ('campaignId' in urlParams) {
                  loggedIn = _config["default"].isLoggedIn();
                  messageId = urlParams['campaignId'];

                  checkCampaignId = /*#__PURE__*/function () {
                    var _ref28 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31() {
                      return _regenerator["default"].wrap(function _callee31$(_context31) {
                        while (1) {
                          switch (_context31.prev = _context31.next) {
                            case 0:
                              _context31.next = 2;
                              return _this3.retrieveAndHandleConfigMessages(messageId);

                            case 2:
                            case "end":
                              return _context31.stop();
                          }
                        }
                      }, _callee31);
                    }));

                    return function checkCampaignId() {
                      return _ref28.apply(this, arguments);
                    };
                  }();

                  if (loggedIn) {
                    checkCampaignId();
                  } else {
                    basePath = _UrlHelper["default"].getBasePath();
                    if (basePath.charAt(0) === '/') basePath = basePath.substr(1, basePath.length);
                    startUrl = _config["default"].cordovaStartUrl();
                    console.log('checkUrlParams', basePath, startUrl);

                    if (basePath === startUrl) {
                      _config["default"].openLogin(function () {
                        return checkCampaignId();
                      });
                    }
                  }
                }

                if (urlParams.referrer) {
                  this.retrieveAndHandleConfigMessages(urlParams.referrer);
                }

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function checkUrlParams() {
        return _checkUrlParams.apply(this, arguments);
      }

      return checkUrlParams;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "onDeviceReadyDone",
    value: function () {
      var _onDeviceReadyDone = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33() {
        return _regenerator["default"].wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));

      function onDeviceReadyDone() {
        return _onDeviceReadyDone.apply(this, arguments);
      }

      return onDeviceReadyDone;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "onAppResumeDone",
    value: function () {
      var _onAppResumeDone = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34() {
        return _regenerator["default"].wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }));

      function onAppResumeDone() {
        return _onAppResumeDone.apply(this, arguments);
      }

      return onAppResumeDone;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "openTutorial",
    value: function () {
      var _openTutorial = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35() {
        return _regenerator["default"].wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function openTutorial() {
        return _openTutorial.apply(this, arguments);
      }

      return openTutorial;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "checkForDrupalLogin",
    value: function () {
      var _checkForDrupalLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee36() {
        return _regenerator["default"].wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36);
      }));

      function checkForDrupalLogin() {
        return _checkForDrupalLogin.apply(this, arguments);
      }

      return checkForDrupalLogin;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "onStoresInitialized",
    value: function () {
      var _onStoresInitialized = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee37() {
        return _regenerator["default"].wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      function onStoresInitialized() {
        return _onStoresInitialized.apply(this, arguments);
      }

      return onStoresInitialized;
    }()
  }, {
    key: "setLanguage",
    value: function setLanguage() {
      if (_config["default"].multiLanguage) {
        var browserLanguage = navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : navigator.language;
        var languageWithoutRegionCode = browserLanguage.toLowerCase().split(/[_-]+/);
        var browserLanguageCode;

        if (languageWithoutRegionCode.length > 1) {
          browserLanguageCode = languageWithoutRegionCode[0].toLowerCase();
        }

        (0, _strings.setCurrentLanguage)(browserLanguageCode);
      } else {
        // set first supported language as language for strings
        // await setCurrentLanguage(target.supportedLanguages[0])
        (0, _strings.setCurrentLanguage)(_config["default"].supportedLanguages[0]);
      }
    }
  }, {
    key: "setDataStoreValuesAccordingToConfig",
    value: function () {
      var _setDataStoreValuesAccordingToConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee38() {
        var data;
        return _regenerator["default"].wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!(_config["default"].defaultDataStoreValues || _config["default"].dataStoreValues)) {
                  _context38.next = 6;
                  break;
                }

                data = {};

                if (_config["default"].dataStoreValues) {
                  (0, _keys["default"])(_config["default"].dataStoreValues).forEach(function (key) {
                    data[key] = _config["default"].dataStoreValues[key];
                  });
                }

                if (_config["default"].defaultDataStoreValues) {
                  (0, _keys["default"])(_config["default"].defaultDataStoreValues).forEach(function (key) {
                    if (!_DataStore["default"].pathExists(key)) {
                      data[key] = _config["default"].defaultDataStoreValues[key];
                    }
                  });
                }

                _context38.next = 6;
                return _DataStore["default"].mergeAndSetData(data);

              case 6:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      function setDataStoreValuesAccordingToConfig() {
        return _setDataStoreValuesAccordingToConfig.apply(this, arguments);
      }

      return setDataStoreValuesAccordingToConfig;
    }()
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return getContext();
    }
  }, {
    key: "addOnlineListener",
    value: function () {
      var _addOnlineListener = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee39() {
        var userAgent, ie10, ie11, deviceReady;
        return _regenerator["default"].wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return (0, _TimeoutHelper.timeout)(500);

              case 2:
                _DeviceInfoHelper["default"].addOnlineListener(this.onOnline);

                if (!this.state.registeredAsSlave) {
                  this.setState({
                    registeredAsSlave: true
                  });
                  (0, _RemoteControlledService.register)(this.onMessageForSlave);
                }

                if (_DeviceInfoHelper["default"].isBrowser()) {
                  // throw DeviceReady Event for Browser (wasn't working sometimes from loadCordova.js)
                  userAgent = window.navigator.userAgent;
                  ie10 = userAgent.indexOf('MSIE');
                  ie11 = userAgent.indexOf('rv:11');

                  if (ie10 > 0 || ie11 > 0) {
                    deviceReady = document.createEvent('HTMLEvents');
                    deviceReady.initEvent('deviceready', true, true);
                    document.dispatchEvent(deviceReady);
                  } else {
                    document.dispatchEvent(new window.CustomEvent('deviceready'));
                  }
                }

                if (_config["default"].androidBackButtonLikeNavigationBarBackButton) {
                  document.addEventListener('backButton', _NavigationManagerCordova["default"].goBack, false);
                } else if (_config["default"].androidBackButtonDisabled) {
                  document.addEventListener('backbutton', _NavigationManagerCordova["default"].goBackButButtonDisabled, false);
                }

              case 6:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function addOnlineListener() {
        return _addOnlineListener.apply(this, arguments);
      }

      return addOnlineListener;
    }()
    /**
     * Overwrite in subclass
     * @returns {Promise<void>}
     */

  }, {
    key: "showWelcomeAlert",
    value: function showWelcomeAlert() {
      if (_config["default"].welcomeAlerts) {
        var welcomeAlert = _config["default"].welcomeAlerts.find(function (block) {
          return block.condition();
        });

        if (welcomeAlert) {
          if (navigator.splashscreen) {
            navigator.splashscreen.hide();
          }

          (0, _MuiAlertHelper.showAlertWithOptions)(welcomeAlert.alert);
          return true;
        }
      }

      return false;
    }
  }, {
    key: "connectToLiveTickerChannels",
    value: function () {
      var _connectToLiveTickerChannels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee41() {
        var _this4 = this;

        var liveTickerChannels;
        return _regenerator["default"].wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return _KESI2Helper["default"].getAllLivetickerChannelIds();

              case 2:
                liveTickerChannels = _context41.sent;
                liveTickerChannels.forEach( /*#__PURE__*/function () {
                  var _ref29 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee40(channel) {
                    return _regenerator["default"].wrap(function _callee40$(_context40) {
                      while (1) {
                        switch (_context40.prev = _context40.next) {
                          case 0:
                            _context40.next = 2;
                            return _MessagingService["default"].registerChannel(channel.channelName, _this4.onMessageForThisApp);

                          case 2:
                          case "end":
                            return _context40.stop();
                        }
                      }
                    }, _callee40);
                  }));

                  return function (_x15) {
                    return _ref29.apply(this, arguments);
                  };
                }());

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LIVETICKER_CHANNELS, liveTickerChannels, false);

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));

      function connectToLiveTickerChannels() {
        return _connectToLiveTickerChannels.apply(this, arguments);
      }

      return connectToLiveTickerChannels;
    }()
  }, {
    key: "connectToChatChannels",
    value: function () {
      var _connectToChatChannels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee43() {
        var _this5 = this;

        var chatChannels;
        return _regenerator["default"].wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return _KESI2Helper["default"].getAllChatChannelIds();

              case 2:
                chatChannels = _context43.sent;
                console.log('chatChannels', chatChannels);
                chatChannels.forEach( /*#__PURE__*/function () {
                  var _ref30 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee42(channel) {
                    return _regenerator["default"].wrap(function _callee42$(_context42) {
                      while (1) {
                        switch (_context42.prev = _context42.next) {
                          case 0:
                            _context42.next = 2;
                            return _MessagingService["default"].registerChannel(channel.channelName, _this5.onMessageForThisApp);

                          case 2:
                          case "end":
                            return _context42.stop();
                        }
                      }
                    }, _callee42);
                  }));

                  return function (_x16) {
                    return _ref30.apply(this, arguments);
                  };
                }());

                if (_config["default"].enableChatWithoutExpert) {
                  _context43.next = 8;
                  break;
                }

                _context43.next = 8;
                return _KESI2Helper["default"].getFinishedChats();

              case 8:
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CHAT_CHANNELS, chatChannels);

              case 9:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      function connectToChatChannels() {
        return _connectToChatChannels.apply(this, arguments);
      }

      return connectToChatChannels;
    }()
  }, {
    key: "connectToTargetChannels",
    value: function () {
      var _connectToTargetChannels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee44() {
        var _iterator, _step, channelName;

        return _regenerator["default"].wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.prev = 0;

                if (!(_config["default"].attachToChannels && _config["default"].attachToChannels.length > 0)) {
                  _context44.next = 20;
                  break;
                }

                _iterator = _createForOfIteratorHelper(_config["default"].attachToChannels);
                _context44.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context44.next = 12;
                  break;
                }

                channelName = _step.value;
                console.log('attaching to ably channel', channelName);
                _context44.next = 10;
                return _MessagingService["default"].registerChannel(channelName, this.onMessageForThisApp);

              case 10:
                _context44.next = 5;
                break;

              case 12:
                _context44.next = 17;
                break;

              case 14:
                _context44.prev = 14;
                _context44.t0 = _context44["catch"](3);

                _iterator.e(_context44.t0);

              case 17:
                _context44.prev = 17;

                _iterator.f();

                return _context44.finish(17);

              case 20:
                _context44.next = 25;
                break;

              case 22:
                _context44.prev = 22;
                _context44.t1 = _context44["catch"](0);
                console.error('error connecting to target channels', _context44.t1);

              case 25:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this, [[0, 22], [3, 14, 17, 20]]);
      }));

      function connectToTargetChannels() {
        return _connectToTargetChannels.apply(this, arguments);
      }

      return connectToTargetChannels;
    }()
  }, {
    key: "connectToTargetChannelPresences",
    value: function () {
      var _connectToTargetChannelPresences = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee46() {
        var _iterator2, _step2, _loop;

        return _regenerator["default"].wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                try {
                  if (_config["default"].attachToChannelsPresences && _config["default"].attachToChannelsPresences.length > 0) {
                    _iterator2 = _createForOfIteratorHelper(_config["default"].attachToChannelsPresences);

                    try {
                      _loop = function _loop() {
                        var channelAndCallback = _step2.value;
                        console.log('attaching to ably channel', channelAndCallback);

                        var subscribe = /*#__PURE__*/function () {
                          var _ref31 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee45() {
                            return _regenerator["default"].wrap(function _callee45$(_context45) {
                              while (1) {
                                switch (_context45.prev = _context45.next) {
                                  case 0:
                                    _context45.next = 2;
                                    return _MessagingService["default"].subscribePresence(channelAndCallback.name, channelAndCallback.callback);

                                  case 2:
                                    channelAndCallback.callback();

                                  case 3:
                                  case "end":
                                    return _context45.stop();
                                }
                              }
                            }, _callee45);
                          }));

                          return function subscribe() {
                            return _ref31.apply(this, arguments);
                          };
                        }();

                        if (_DeviceInfoHelper["default"].isOnline()) {
                          console.log('attaching to ably channel - online', channelAndCallback);
                          subscribe();
                        } else {
                          console.log('attaching to ably channel - offline', channelAndCallback);

                          _DeviceInfoHelper["default"].addOnlineListener(function () {
                            subscribe();
                          });
                        }
                      };

                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        _loop();
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                } catch (error) {
                  console.error('error connecting to target channels', error);
                }

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      function connectToTargetChannelPresences() {
        return _connectToTargetChannelPresences.apply(this, arguments);
      }

      return connectToTargetChannelPresences;
    }()
  }, {
    key: "disconnectFromTargetChannelPresences",
    value: function () {
      var _disconnectFromTargetChannelPresences = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee47() {
        var _iterator3, _step3, channelAndCallback;

        return _regenerator["default"].wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.prev = 0;

                if (!(_config["default"].attachToChannelsPresences && _config["default"].attachToChannelsPresences.length > 0)) {
                  _context47.next = 19;
                  break;
                }

                _iterator3 = _createForOfIteratorHelper(_config["default"].attachToChannelsPresences);
                _context47.prev = 3;

                _iterator3.s();

              case 5:
                if ((_step3 = _iterator3.n()).done) {
                  _context47.next = 11;
                  break;
                }

                channelAndCallback = _step3.value;
                _context47.next = 9;
                return _MessagingService["default"].leavePresence(channelAndCallback.name);

              case 9:
                _context47.next = 5;
                break;

              case 11:
                _context47.next = 16;
                break;

              case 13:
                _context47.prev = 13;
                _context47.t0 = _context47["catch"](3);

                _iterator3.e(_context47.t0);

              case 16:
                _context47.prev = 16;

                _iterator3.f();

                return _context47.finish(16);

              case 19:
                _context47.next = 24;
                break;

              case 21:
                _context47.prev = 21;
                _context47.t1 = _context47["catch"](0);
                console.error('error connecting to target channels', _context47.t1);

              case 24:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, null, [[0, 21], [3, 13, 16, 19]]);
      }));

      function disconnectFromTargetChannelPresences() {
        return _disconnectFromTargetChannelPresences.apply(this, arguments);
      }

      return disconnectFromTargetChannelPresences;
    }()
  }, {
    key: "onNotificationReceived",
    value: function () {
      var _onNotificationReceived = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee48(data) {
        var pathToNavigateTo, dataStoreChanges, candidateEvent, okButton, buttons, actionParams, token, messageObj, _messageObj, currentlyRead, _data, _actionParams, id, path, content, activityTags, _okButton, _buttons, _actionParams2, myData, user, reactButton, _messageObj2, _messageObj3, _messageObj4, _buttons2, _messageObj5, _messageObj6, _messageObj7;

        return _regenerator["default"].wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                console.log('push notification received (or retry button pushed):', data);
                (0, _LogService.pushGenericLogMessage)({
                  action: 'pushMessage',
                  message: data
                });
                pathToNavigateTo = null;
                console.log('onNotificationReceived', data, data.wasTapped, data.systemAction);

                if (!data.dataStoreChanges) {
                  _context48.next = 14;
                  break;
                }

                _context48.prev = 5;
                dataStoreChanges = JSON.parse(data.dataStoreChanges);
                _context48.next = 9;
                return _DataStore["default"].setData(dataStoreChanges);

              case 9:
                _context48.next = 14;
                break;

              case 11:
                _context48.prev = 11;
                _context48.t0 = _context48["catch"](5);
                console.error('Error applying dataStoreChanges from push message', _context48.t0, data.dataStoreChanges);

              case 14:
                if (data.systemAction === 'updateCandidates') {
                  console.log('we got updateCandidates');
                  candidateEvent = new window.CustomEvent('updateCandidates');
                  document.dispatchEvent(candidateEvent);
                }

                if (!(data.systemAction === 'presentLoginToken')) {
                  _context48.next = 21;
                  break;
                }

                console.log('push presentLoginToken');
                okButton = {
                  label: (0, _strings2.getString)('OK'),
                  callback: function callback() {}
                };
                buttons = [okButton];

                if (data.actionParams) {
                  actionParams = typeof data.actionParams === 'string' ? JSON.parse(data.actionParams) : data.actionParams;
                  token = actionParams.token;

                  if (_DeviceInfoHelper["default"].isAndroid()) {
                    messageObj = data;
                    console.log('push presentLoginToken', messageObj);

                    if (messageObj && messageObj.notification_title && messageObj.notification_message && token) {
                      (0, _MuiAlertHelper.showAlertWithOptions)({
                        message: "Das einzugebende Token ist: ".concat(token),
                        title: messageObj.notification_title,
                        buttons: buttons,
                        size: 'wide'
                      });
                    }
                  } else {
                    _messageObj = data.aps && data.aps.alert ? data.aps.alert : null;

                    if (_messageObj && _messageObj.title && _messageObj.body) {
                      (0, _MuiAlertHelper.showAlertWithOptions)({
                        message: "Das einzugebende Token ist: ".concat(token),
                        title: _messageObj.title,
                        buttons: buttons,
                        size: 'wide'
                      });
                    }
                  }
                }

                return _context48.abrupt("return");

              case 21:
                if (data.systemAction === 'pullSnoo') {
                  currentlyRead = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES) || 0; // no need to wait for the saving

                  _data = {};
                  _data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES] = currentlyRead + 1;
                  _data[_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER] = (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER) || 0) + 1;

                  _DataStore["default"].setData(_data);
                }

                if (data.systemAction === 'navigateTo') {
                  _actionParams = JSON.parse(data.actionParams);

                  if (_actionParams) {
                    id = _actionParams.id;
                    path = _KESI2Helper["default"].getPathToContentInTree(id);
                    content = _KESI2Helper["default"].getContentById(id);
                    console.log('navigateTo', id, path, content);

                    if (path) {
                      if (path.length > 1 && content.type === 'nugget') {
                        // Remove the last element if it was a nugget, cant link to nuggets right now
                        (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
                      }

                      pathToNavigateTo = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));
                    }
                  }
                }

                if (!(data.systemAction === 'ffbEvent')) {
                  _context48.next = 25;
                  break;
                }

                return _context48.abrupt("return");

              case 25:
                console.log('systemAction', data.systemAction);

                if (data.systemAction === 'structureUpdated') {
                  (0, _ErgoStructureHelper.getStructureData)();
                }

                activityTags = (0, _values["default"])(_ErgoActivityConstants.ACTIVITY_TAGS);

                if (!(activityTags.indexOf(data.systemAction) > -1)) {
                  _context48.next = 36;
                  break;
                }

                _okButton = {
                  label: (0, _strings2.getString)('OK'),
                  callback: function callback() {}
                };
                _buttons = [_okButton];
                _actionParams2 = JSON.parse(data.actionParams);

                if (_actionParams2 && _actionParams2.username) {
                  myData = this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA];
                  user = (0, _ErgoStructureHelper.getUserDataByUsername)(_actionParams2.username);

                  if (user) {
                    reactButton = {
                      label: (0, _strings2.getString)('REACT'),
                      callback: function callback() {
                        setTimeout(function () {
                          _PushHelper["default"].showPushDialog(user, myData, function () {});
                        });
                      }
                    };

                    _buttons.push(reactButton);
                  }
                } // Added Browser -> we are handling SysMessages with action "push" like push messages


                if (_DeviceInfoHelper["default"].isAndroid()) {
                  _messageObj2 = data;

                  if (_messageObj2 && _messageObj2.notification_title && _messageObj2.notification_message) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj2.notification_message,
                      title: _messageObj2.notification_title,
                      buttons: _buttons,
                      size: 'wide'
                    });
                  }
                } else if (_DeviceInfoHelper["default"].isBrowser()) {
                  _messageObj3 = data;

                  if (_messageObj3 && _messageObj3.title && _messageObj3.dialogMessage) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj3.dialogMessage,
                      title: _messageObj3.title,
                      buttons: _buttons,
                      size: 'wide'
                    });
                  }
                } else {
                  _messageObj4 = data.aps && data.aps.alert ? data.aps.alert : null;

                  if (_messageObj4 && _messageObj4.title && _messageObj4.body) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj4.body,
                      title: _messageObj4.title,
                      buttons: _buttons,
                      size: 'wide'
                    });
                  }
                }

                _context48.next = 43;
                break;

              case 36:
                _buttons2 = [{
                  label: (0, _strings2.getString)('OK'),
                  callback: function callback() {}
                }];

                if (pathToNavigateTo) {
                  _buttons2.push({
                    label: (0, _strings2.getString)('MORE_INFOS'),
                    callback: function callback() {
                      setTimeout(function () {
                        _NavigationManagerCordova["default"].jumpToKesiUrl(pathToNavigateTo);
                      });
                    }
                  });
                }

                if (!(data.systemAction === 'navigateTo' && !pathToNavigateTo && this.state.updateCheckComplete !== true)) {
                  _context48.next = 42;
                  break;
                }

                this.navigateToUpdateAlert = (0, _MuiAlertHelper.showAlertWithOptions)({
                  message: 'Es wird grade ein Update des Inhalts durchgeführt. Nach dem Update geht es sofort weiter.',
                  title: '',
                  size: 'wide',
                  buttons: [{
                    label: (0, _strings2.getString)('OK'),
                    callback: function callback() {}
                  }]
                });
                this.pushToShowWhenUpdateIsDone = data;
                return _context48.abrupt("return");

              case 42:
                if (_DeviceInfoHelper["default"].isAndroid()) {
                  _messageObj5 = data;

                  if (_messageObj5 && _messageObj5.notification_title && _messageObj5.notification_message) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj5.notification_message,
                      title: _messageObj5.notification_title,
                      buttons: _buttons2,
                      size: 'wide'
                    });
                  }
                } else if (_DeviceInfoHelper["default"].isBrowser()) {
                  _messageObj6 = data;

                  if (_messageObj6 && _messageObj6.title && _messageObj6.dialogMessage) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj6.dialogMessage,
                      title: _messageObj6.title,
                      buttons: _buttons2,
                      size: 'wide'
                    });
                  }
                } else {
                  _messageObj7 = data.aps && data.aps.alert ? data.aps.alert : null;

                  if (_messageObj7 && _messageObj7.title && _messageObj7.body) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      message: _messageObj7.body,
                      title: _messageObj7.title,
                      buttons: _buttons2,
                      size: 'wide'
                    });
                  }
                }

              case 43:
                // showAlertInDebugMode('content see next alert', 'PUSH MESSAGE RECEIVED')
                // showAlertInDebugMode(JSON.stringify(data), 'PUSH MESSAGE RECEIVED')
                // showAlert('content see next alert', 'PUSH MESSAGE RECEIVED')
                // showAlert(JSON.stringify(data), 'PUSH MESSAGE RECEIVED')
                if (_config["default"].goHomeOnPush) {
                  _NavigationManagerCordova["default"].goHome();
                }

              case 44:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this, [[5, 11]]);
      }));

      function onNotificationReceived(_x17) {
        return _onNotificationReceived.apply(this, arguments);
      }

      return onNotificationReceived;
    }()
  }, {
    key: "registerTargetSpecificChannels",

    /**
     * Overwrite in target's AppCordova.js
     * @returns true if handled and false if not
     */
    value: function () {
      var _registerTargetSpecificChannels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee49() {
        return _regenerator["default"].wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49);
      }));

      function registerTargetSpecificChannels() {
        return _registerTargetSpecificChannels.apply(this, arguments);
      }

      return registerTargetSpecificChannels;
    }()
    /**
     * Overwrite in target's AppCordova.js
     * @returns true if handled and false if not
     */

  }, {
    key: "unregisterFromTargetSpecificChannels",
    value: function () {
      var _unregisterFromTargetSpecificChannels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee50() {
        return _regenerator["default"].wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50);
      }));

      function unregisterFromTargetSpecificChannels() {
        return _unregisterFromTargetSpecificChannels.apply(this, arguments);
      }

      return unregisterFromTargetSpecificChannels;
    }()
    /**
     * Overwrite in target's AppCordova.js
     * @param message
     * @param channelName
     * @returns true if handled and false if not
     */

  }, {
    key: "handleTargetSpecificAblyMessage",
    value: function handleTargetSpecificAblyMessage(message, channelName) {
      return false;
    }
  }, {
    key: "retrieveAndHandleConfigMessages",
    value: function () {
      var _retrieveAndHandleConfigMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee51(referrer) {
        var options, closeOrUpdateDialogFn, token, response, data;
        return _regenerator["default"].wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                console.log('going to get config messages for referrer', referrer);
                _context51.prev = 1;
                _context51.next = 4;
                return _OnlineAlertHelper["default"].waitForOnlineWithAlert(false, true, (0, _strings2.getString)('OFFLINE'), (0, _strings2.getString)('GO_ONLINE_TO_REGISTER_AUTOMATICALLY'));

              case 4:
                _context51.next = 10;
                break;

              case 6:
                _context51.prev = 6;
                _context51.t0 = _context51["catch"](1);
                console.error('error waiting for device to be online', _context51.t0);
                throw _context51.t0;

              case 10:
                options = {
                  title: (0, _strings2.getString)('GET_DATA_FROM_SERVER_TITLE'),
                  message: (0, _strings2.getString)('GET_DATA_FROM_SERVER_MESSAGE'),
                  buttons: [],
                  showCloseButton: false,
                  severity: _MuiAlertHelper.SEVERITIES.LOW
                };
                closeOrUpdateDialogFn = (0, _MuiAlertHelper.showAlertWithOptions)(options);
                _context51.next = 14;
                return _RegisterInstance["default"].getAccessToken('dataStore:read');

              case 14:
                token = _context51.sent;
                _context51.prev = 15;
                _context51.next = 18;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/rest/api/v1/dataStore/configMessages/").concat(referrer), null, null, 10000, 2, 'Bearer ' + token);

              case 18:
                response = _context51.sent;
                data = response.data;
                console.log('retrieveAndHandleConfigMessages', data);

                if (!(!data || !data.success || !data.sysMessages)) {
                  _context51.next = 25;
                  break;
                }

                closeOrUpdateDialogFn();
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _strings2.getString)('ERROR'),
                  message: (0, _strings2.getString)('INVALID_REFERRER'),
                  showCloseButton: false,
                  buttons: []
                });
                return _context51.abrupt("return");

              case 25:
                _context51.next = 27;
                return (0, _SysMessageHelper.handleSysMessages)(this, data.sysMessages, true);

              case 27:
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.APPSFLYER_REFERRER, referrer);

                closeOrUpdateDialogFn();
                _context51.next = 36;
                break;

              case 31:
                _context51.prev = 31;
                _context51.t1 = _context51["catch"](15);
                console.log('error retrieving config messages', _context51.t1);

                if (closeOrUpdateDialogFn) {
                  closeOrUpdateDialogFn();
                }

                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _strings2.getString)('ERROR'),
                  message: (0, _ErrorHelper.getErrorMessage)(_context51.t1)
                });

              case 36:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this, [[1, 6], [15, 31]]);
      }));

      function retrieveAndHandleConfigMessages(_x18) {
        return _retrieveAndHandleConfigMessages.apply(this, arguments);
      }

      return retrieveAndHandleConfigMessages;
    }()
  }, {
    key: "renderAnimatedLoading",
    value: function renderAnimatedLoading() {
      var _this6 = this;

      if (_config["default"].hasAnimatedSplashscreen) {
        return /*#__PURE__*/_react["default"].createElement("video", {
          id: SPLASH_SCREEN_VIDEO_ID // style={{ maxHeight: 'calc(100vh - 30px)', position: 'relative', left: '50%', transform: 'translateX(-50%)' }}
          ,
          style: {
            height: '100vh',
            maxWidth: '100vw',
            position: 'relative',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          src: 'splashscreen.mp4',
          onEnded: function onEnded() {
            return setTimeout(function () {
              return _this6.setState({
                animatedSplashscreenFinished: true
              });
            }, 200);
          } // autoPlay
          ,
          muted: true // must be set otherwise iOS will always show video in fullscreen
          ,
          playsinline: true,
          webkitPlaysinline: true
        });
      }
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var _this7 = this;

      if (_config["default"].mustShowLoading && !this.spinnerStartTime) {
        this.spinnerStartTime = (0, _now["default"])();
        console.log("starting timer at ".concat(this.spinnerStartTime, "..."));

        if (_DeviceInfoHelper["default"].isBrowser()) {
          var search = window.location.search;
          var id = search.replace(/(.*id=)([^&]+)(.*)/, '$2');

          if (_config["default"].useDeutscheWohnenId) {
            // we dont have an id in the deuwo url so dont check for that here, instead end loading automatically
            setTimeout(function () {
              console.log('ending timer...');
              console.log("ending timer at ".concat((0, _now["default"])(), "..."));

              _this7.setState({
                endForcedLoading: true
              });
            }, _config["default"].showLoadingTimeout);
          } else {
            if (id) {
              console.log('renderLoading', id); // only start loading timer (only used in snomm eurofh and deutschewohnen_oauth) if we have an id in the search

              setTimeout(function () {
                console.log('ending timer...');
                console.log("ending timer at ".concat((0, _now["default"])(), "..."));

                _this7.setState({
                  endForcedLoading: true
                });
              }, _config["default"].showLoadingTimeout);
            } else if (_config["default"].useEurofhLinkId && _config["default"].ignoreUrlParam) {
              setTimeout(function () {
                console.log('ending timer...');
                console.log("ending timer at ".concat((0, _now["default"])(), "..."));

                _this7.setState({
                  endForcedLoading: true
                });
              }, _config["default"].showLoadingTimeout);
            }
          }
        }
      }

      var loggedOut = false;
      var loggedOutArr = window.location.href.split('loggedOut=');

      if (loggedOutArr.length > 1) {
        if (loggedOutArr[1] === 'true') {
          loggedOut = true;
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, _config["default"].useKesiSpinner && _config["default"].getKesiSpinner ? _config["default"].getKesiSpinner(_config["default"].useWebLogin ? !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) : false, _config["default"].useWebLogin ? loggedOut : false) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'fixed',
          top: '60%',
          left: '50%',
          transform: 'translateX(-50%)',
          paddingTop: '20px',
          fontSize: '20px',
          color: '#000000',
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, _config["default"].loadingText ? '' : this.state.downloadProgressText ? this.state.downloadProgressText : ''), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, _config["default"].loadingText ? '' : this.state.downloadProgress ? "".concat(this.state.downloadProgress, " %") : ''), /*#__PURE__*/_react["default"].createElement("div", null, _config["default"].showProgressBar && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '20px'
        }
      }, this.renderProgressBar())))));
    }
  }, {
    key: "renderNavigationBar",
    value: function renderNavigationBar() {
      return /*#__PURE__*/_react["default"].createElement(_NavigationBar["default"], {
        onMenuClicked: this.openMenu,
        onRefresh: this.reloadContent,
        sidebarWidth: this.state.sidebarDocked ? _cssConstants["default"].mainMenuWidth : '0',
        sidebarDocked: this.state.sidebarDocked,
        title: this.state.title,
        count: this.state.count,
        showMenuButton: _config["default"].hasSlidingMenu,
        showBackButton: this.state.showBackButton,
        backButtonFunc: (0, _ArrayHelper.getLastElement)(this.state.backButtonFunc),
        homeButtonFunc: this.goHome,
        showFavButton: this.state.showFavButton,
        reloadContent: this.reloadContent,
        showSettingsDialog: this.showSettingsDialog,
        showGlossary: this.showGlossary,
        currentPath: this.props.children.props.location.pathname
      });
    }
  }, {
    key: "renderBottomBar",
    value: function renderBottomBar() {
      if (_config["default"].showErvBottomBar) {
        return /*#__PURE__*/_react["default"].createElement(_ErvBottomBar["default"], {
          renderUpdateValue: this.state.renderUpdateValue,
          onTabClicked: this.hideIncidentView,
          setBackButtonFunc: this.setBackButtonFunc
        });
      }

      if (_config["default"].bottomBarElements && _config["default"].bottomBarElements.length > 0) {
        return /*#__PURE__*/_react["default"].createElement(_BottomBar["default"], {
          elements: _config["default"].bottomBarElements,
          hidden: this.state.hideBottomBar
        });
      }

      return null;
    }
  }, {
    key: "prerenderChildren",
    value: function prerenderChildren() {
      // TODO: Change for equeoQD -> no prerendering -> see app.js
      this.renderedChildren = /*#__PURE__*/_react["default"].cloneElement(this.props.children, {
        reloadContent: this.reloadContent,
        updateContent: this.updateContent,
        setTitle: this.setTitle,
        setCount: this.setUsageCount,
        setBodyPositionFixed: this.setBodyPositionFixed,
        updateValue: this.state.currentUpdateValue,
        setScrollBarHidden: this.setScrollBarHidden,
        setBackButtonFunc: this.setBackButtonFunc,
        setShowFavButton: this.setShowFavButton,
        showSettingsDialog: this.showSettingsDialog
      });
    }
  }, {
    key: "getRenderedChildren",
    value: function getRenderedChildren() {
      if (!this.renderedChildren) {
        this.prerenderChildren();
      }

      return this.renderedChildren;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return this.state.loading ? this.renderLoading() : this.getRenderedChildren();
    }
  }, {
    key: "renderSlidingMenu",

    /**
     * Overwrite in target specific subclass if needed.
     */
    value: function renderSlidingMenu() {
      return null; // THIS IS HOW IT COULD LOOK LIKE
      // const views = this.renderViews()
      // return (
      //   <MainMenuCordova
      //     open={this.state.menuOpen}
      //     onSetOpen={this.setMenuOpen}
      //     onRefresh={this.reloadContent}
      //     sidebarDocked={this.state.sidebarDocked}
      //     width={constants.mainMenuWidth}
      //   >
      //     {views}
      //     <AlertHelper />
      //     <MuiAlertHelper />
      //     <SnackbarHelper />
      //   </MainMenuCordova>
      // )
    }
  }, {
    key: "renderAppStartDialog",
    value: function renderAppStartDialog() {
      return null;
    }
  }, {
    key: "renderViews",
    value: function renderViews() {
      console.log('renderViews (app generic)');
      var content = null;
      var bottomStyle = _config["default"].bottomBar ? {
        paddingBottom: '64px'
      } : {};

      if (_config["default"].homeScrollEnabled) {
        content = /*#__PURE__*/_react["default"].createElement("div", {
          id: PAGE_SCROLL_ID,
          className: "".concat(_AppCordovaGeneric["default"].pageScroll, " ").concat(!_config["default"].showScrollBar && this.state.scrollBarHidden ? _base["default"].scrollbarMinWidth : ''),
          onScroll: this.onPageScroll,
          style: bottomStyle
        }, this.renderContent());
      } else {
        content = /*#__PURE__*/_react["default"].createElement("div", {
          id: 'tileRoot',
          className: "".concat(_AppCordovaGeneric["default"].pageNoScroll),
          style: bottomStyle
        }, this.renderContent());
      }

      var navBarDefaultColor = _NavigationManagerCordova["default"].getNavbarBackgroundColor();

      var navBarColor = (_config["default"].useTileBackgroundColorInTile || _config["default"].openTilesInFullScreen) && navBarDefaultColor ? navBarDefaultColor : _cssConstants["default"].colors.navbarBackground;
      return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
        "in": true,
        timeout: 1500
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100vh'
        }
      }, content, this.renderAppStartDialog(), _config["default"].showGlossarButton ? /*#__PURE__*/_react["default"].createElement(_Glossary["default"], {
        open: this.state.showGlossary,
        closeDialog: this.closeGlossary,
        setTitle: this.setTitle
      }) : null, _DeviceInfoHelper["default"].isiOS() && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: navBarColor
        },
        className: _AppCordovaGeneric["default"].safeAreaContainerTop
      }, "\xA0"), this.renderNavigationBar(), this.renderBottomBar(), _DeviceInfoHelper["default"].isiOS() && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: _config["default"].useNavBarColorInSafeAreaBottom ? navBarColor : _cssConstants["default"].colors.bottomBackground ? _cssConstants["default"].colors.bottomBackground : '#FFFFFF'
        },
        className: _AppCordovaGeneric["default"].safeAreaContainerBottom
      }, "\xA0")));
    }
  }, {
    key: "render",
    value: function render() {
      var animatedLoadingScreen = this.renderAnimatedLoading();
      var loadingScreen = this.renderLoading();
      var showAnimatedSplashscreen = _config["default"].hasAnimatedSplashscreen && (!this.state.deviceReady || !this.state.animatedSplashscreenFinished || !_config["default"].useEurofhLinkId && !_config["default"].useSnomLinkId && !_config["default"].useDeutscheWohnenId && this.state.loading || !this.state.storeInitialized || !this.state.deepLinkChecked);

      if (showAnimatedSplashscreen) {
        return /*#__PURE__*/_react["default"].createElement("div", null, animatedLoadingScreen, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null));
      }

      if (!this.state.deviceReady) {
        return /*#__PURE__*/_react["default"].createElement("div", null, loadingScreen, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null));
      }

      if (_config["default"].useWebLogin && this.state.storeInitialized && this.state.deepLinkChecked && !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : null
        }, _config["default"].loginComponent, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            opacity: 0
          }
        }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: 0,
            height: 0,
            opacity: 0,
            position: 'absolute',
            top: -10000,
            left: -10000
          },
          type: "text",
          id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
        })));
      }

      if (_config["default"].useSnomLinkId && (this.state.storeInitialized && this.state.deepLinkChecked && !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) || !this.state.endForcedLoading)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : null
        }, loadingScreen, _config["default"].loginComponent, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            opacity: 0
          }
        }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: 0,
            height: 0,
            opacity: 0,
            position: 'absolute',
            top: -10000,
            left: -10000
          },
          type: "text",
          id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
        })));
      }

      if (_config["default"].useEurofhLinkId && (this.state.storeInitialized && this.state.deepLinkChecked && !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) || !this.state.endForcedLoading)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : null
        }, loadingScreen, _config["default"].loginComponent, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            opacity: 0
          }
        }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: 0,
            height: 0,
            opacity: 0,
            position: 'absolute',
            top: -10000,
            left: -10000
          },
          type: "text",
          id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
        })));
      }

      if (_config["default"].useDeutscheWohnenId && (this.state.storeInitialized && this.state.deepLinkChecked && !_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) || !this.state.endForcedLoading)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : null
        }, loadingScreen, _config["default"].loginComponent, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            opacity: 0
          }
        }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: 0,
            height: 0,
            opacity: 0,
            position: 'absolute',
            top: -10000,
            left: -10000
          },
          type: "text",
          id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
        })));
      }

      if (!_config["default"].useSnomLinkId && !_config["default"].useEurofhLinkId && !_config["default"].useDeutscheWohnenId && this.state.loading || !this.state.storeInitialized || !this.state.deepLinkChecked) {
        if (!_config["default"].useSnomLinkId && !_config["default"].useEurofhLinkId && !_config["default"].useDeutscheWohnenId && this.state.loading) {
          this.setBodyPositionFixed(true);
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : null
        }, loadingScreen, /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            opacity: 0
          }
        }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: 0,
            height: 0,
            opacity: 0,
            position: 'absolute',
            top: -10000,
            left: -10000
          },
          type: "text",
          id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
        })));
      }

      this.setBodyPositionFixed(true);
      var views = this.renderViews();

      if (_config["default"].hasSlidingMenu) {
        return this.renderSlidingMenu();
      }

      var styleIEFix = _DeviceInfoHelper["default"].isInternetExplorer() ? _AppCordovaGeneric["default"].ieZFix : '';
      var activated = this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] === true;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100vh'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: styleIEFix
      }, _config["default"].showUpdateWindow && this.state.showUpdateWindow ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].updateContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].updateContainerTitle
      }, this.state.downloadProgressText), /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].updateContainerSpinnerContainer
      }, this.state.downloadProgressText === (0, _strings2.getString)('UPDATE_CHECK') && /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
        variant: 'indeterminate',
        className: _AppCordovaGeneric["default"].updateContainerSpinner
      }), this.state.downloadProgressText !== (0, _strings2.getString)('UPDATE_CHECK') && /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
        variant: 'static',
        value: this.state.downloadProgress,
        className: _AppCordovaGeneric["default"].updateContainerSpinner
      }), this.state.downloadProgressText !== (0, _strings2.getString)('UPDATE_CHECK') && /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].updateContainerPercentage
      }, this.state.downloadProgress ? "".concat(this.state.downloadProgress, "%") : '0%'))) : null, views, _config["default"].showDemoFlag && activated || _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_DEMO_MODE) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _AppCordovaGeneric["default"].demoFlag
      }, "DEMO") : '', /*#__PURE__*/_react["default"].createElement(_AlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_MuiAlertHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_PauseHelper["default"], null), /*#__PURE__*/_react["default"].createElement(_SnackbarHelper["default"], null), /*#__PURE__*/_react["default"].createElement("label", {
        style: {
          opacity: 0
        }
      }, "Unfokushelfer", /*#__PURE__*/_react["default"].createElement("input", {
        style: {
          width: 0,
          height: 0,
          opacity: 0,
          position: 'absolute',
          top: -10000,
          left: -10000
        },
        type: "text",
        id: _KeyboardHelper.UNFOCUS_ELEMENT_ID
      }))));
    }
  }]);
  return AppCordovaGeneric;
}(_DataStoreComponent2["default"]);

AppCordovaGeneric.addOnPageScrollListener = function (listener) {
  var callWithCurrentValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  onPageScrollListeners.push(listener);

  if (callWithCurrentValue) {
    if (document) {
      var pageScroll = document.getElementById(PAGE_SCROLL_ID);

      if (pageScroll) {
        var scrollTop = pageScroll.scrollTop;
        listener(scrollTop);
        return;
      }
    }

    listener(0);
  }
};

AppCordovaGeneric.removeOnPageScrollListener = function (listener) {
  var index = onPageScrollListeners.indexOf(listener);

  if (index >= 0) {
    onPageScrollListeners.splice(index, 1);
  }
};

AppCordovaGeneric.addRemoteScrollListener = function (contentId, callback) {
  console.log("registering scroll listener for content with id ".concat(contentId));
  remoteScrollCallbacks[contentId] = callback;
};

AppCordovaGeneric.removeRemoteScrollListener = function (contentId) {
  delete remoteScrollCallbacks[contentId];
};

AppCordovaGeneric.propTypes = {
  children: _propTypes["default"].node
};
AppCordovaGeneric.childContextTypes = {
  contentStore: _propTypes["default"].object.isRequired,
  dataStore: _propTypes["default"].object.isRequired,
  relevancesStore: _propTypes["default"].object.isRequired,
  themeStore: _propTypes["default"].object.isRequired,
  usageStore: _propTypes["default"].object.isRequired
};
var _default = AppCordovaGeneric;
exports["default"] = _default;